{
    "site_name": "PomBase",
    "database_name": "PomBase",
    "database_prefix": "PomBase",
    "database_long_name": "The Schizosaccharomyces pombe genome database",
    "database_citation": "PMID:22039153",
    "logo_file_name": "pombase-logo.png",
    "small_logo_file_name": "pombase-logo-small.png",
    "tiny_logo_file_name": "pombase-logo-tiny.png",
    "header_background_file_name": "header-background.jpg",
    "funder": "Wellcome Trust",
    "site_description": "A comprehensive database for the fission yeast <i>Schizosaccharomyces pombe</i>, providing structural and functional annotation, literature curation and access to large-scale data sets",
    "welcome_message": "Comprehensive, curated, connected genomic, genetic and molecular data for <i>Schizosaccharomyces pombe</i>",
    "footer": {
        "funders": "PomBase is funded by the <a href='https://www.wellcome.ac.uk/'>Wellcome Trust</a>, run by a consortium comprising the <a href='https://www.cam.ac.uk/'>University of Cambridge</a>, <a href='https://www.ucl.ac.uk/'>University College London</a>, and hosted by the <a href='https://www.babraham.ac.uk'>Babraham Institute</a>.",
        "show_elixir_and_gbc_message": true,
        "logos": [
            {
                "url": "https://wellcome.ac.uk/",
                "image": "wellcome-logo-64px.png",
                "alt_text": "Wellcome Trust"
            },
            {
                "url": "https://www.sysbiol.cam.ac.uk/",
                "image": "sysbiol_logo-64px.png",
                "alt_text": "Cambridge Systems Biology Centre"
            },
            {
                "url": "https://www.cam.ac.uk/",
                "image": "cambridge-logo-64px.png",
                "alt_text": "University of Cambridge"
            },
            {
                "url": "https://www.ucl.ac.uk/",
                "image": "ucl_logo-64px.png",
                "alt_text": "University College London"
            },
            {
                "url": "https://elixir-europe.org/",
                "image": "elixir-logo-64px.png",
                "alt_text": "ELIXIR"
            },
            {
                "url": "https://globalbiodata.org/scientific-activities/global-core-biodata-resources/",
                "image": "GCBR-Logo-RGB-64px.png",
                "alt_text": "Global Core Biodata Resource"
            }
        ]
    },
    "load_organism_taxonid": 4896,
    "base_url": "https://www.pombase.org",
    "helpdesk_address": "helpdesk@pombase.org",
    "show_names_of_staff_curators": false,
    "show_names_of_staff_file_curators": false,
    "gene_systematic_identifier_re": "^SP[\\w\\d]+\\.\\d+[wc]?$",
    "transcript_systematic_identifier_re": "^SP[\\w\\d]+\\.\\d+[wc]?.\\d+$",
    "details_popup_delay": 500,
    "data_sources": {
        "interactions": [
            {
                "name": "BioGRID",
                "url": "https://thebiogrid.org/"
            }
        ]
    },
    "example_pages": {
        "gene": "SPBC216.07c",
        "term": "GO:0000070",
        "reference": "PMID:39094570",
        "gocam": "6796b94c00006848"
    },
    "social_media": {
        "bluesky": "pombase.bsky.social",
        "mastodon": "https://mstdn.science/@pombase",
        "github": "pombase",
        "slack": "https://spombe.slack.com/",
        "facebook": "pombase",
        "linkedin": "https://www.linkedin.com/groups/5122686"
    },
    "has_disease_annotation": true,
    "has_unknowns_list": true,
    "has_characterisation_status": true,
    "news_on_front_page": true,
    "front_box_content": [
        {
            "summary": "<div class='front-box-logo'><img width='64px' src='/assets/newsfeed/13th-international-fission-yeasts-meeting-logo-64x64px.png'/></div><b>Save the date!</b><h5>13th International Fission Yeasts Meeting, July 12-16, 2027</h5><div>",
            "details": "<div><em>From the organisers:</em></div> <div> The 13th International Fission Yeasts Meeting will take place from July 12 to 16, 2027 in Bordeaux, France. The meeting will be held in the beautiful and historic Palais de la Bourse, located in the heart of the city and on the quays of the Garonne River. </div> <div> <a href='https://event.gayakoa.com/13thFissionYeastMeeting'>Visit the conference website for more information</a></div><div><a href='https://event.gayakoa.com/13thFissionYeastMeeting'><img alt='Visit the conference website for more information' src='/assets/newsfeed/13th-international-fission-yeasts-meeting-banner-small.png'/></a></div>",
            "frequency": 2
        },
        {
            "summary": "<b>Call for Speakers and Organisers - pombeTalks S07</b>",
            "details": "<div><em>From the The pombeTalks Organising Team:</em></div><div>Dear fission yeast enthusiasts,</div><div>We are very excited to announce Season 07 of <a href='/community/pombetalks'>pombeTalks</a>, launching this October 2026! We are now reaching out for speakers- whether you have an exciting fission yeast story taking shape or a project that seems to be going nowhere and could benefit from some feedback and discussion, this is for you. We would love to hear about your exciting findings, ideas, and challenges and we look forward to having many of you join us!</div><div>See <a href='https://lists.cam.ac.uk/sympa/arc/ucam-pombelist/2026-08/msg00006.html'>pombeList</a> for more details</div>"
        }
    ],
    "has_admin_curation": true,
    "no_gene_name_route": "/submit-data/gene-names",
    "ensembl_blast_url": "https://fungi.ensembl.org/Schizosaccharomyces_pombe/Tools/Blast",
    "jackhmmer_search_url": "https://www.ebi.ac.uk/Tools/hmmer/search/jackhmmer",
    "ebi_tools_url": "https://www.ebi.ac.uk/jdispatcher/sss",
    "pdbe_entry_url": "https://www.ebi.ac.uk/pdbe-srv/view/entry",
    "pdbe_image_url": "https://www.ebi.ac.uk/pdbe/static/entry/<<PDB_ID>>_deposited_chain_front_image-200x200.png",
    "rcsb_pdb_entry_url": "https://www.rcsb.org/structure",
    "seq_and_features_download_url": "https://curation.pombase.org/allele_qc/genome_region?systematic_id=<<IDENTIFIER>>&format=<<FORMAT>>&upstream=<<UPSTREAM_BASES>>&downstream=<<DOWNSTREAM_BASES>>",
    "canto_url": "https://curation.pombase.org/pombe",
    "canto_documentation_url": "https://pombase.github.io/canto_tutorial/",
    "community_mailing_list": {
        "url": "https://lists.cam.ac.uk/sympa/info/ucam-pombelist",
        "icon": "pombe_email_icon.png",
        "title": "S. pombe community mailing list"
    },
    "canto_data_config": {
        "browser_track_triage_types": [
            "Browser datasets, to host",
            "Browser datasets, hosted",
            "Transposon related",
            "Mating-type related",
            "DNA replication related",
            "DNA recombination related",
            "Mitochondrial sequence related"
        ]
    },
    "doc_page_aliases": {
        "/browse-curation/fission-yeast-go-slim-terms": "/browse-curation/fission-yeast-bp-go-slim-terms",
        "/documentation/misc-sequence-features": "/documentation/non-gene-features",
        "/status/genome-overview": "/status/statistics"
    },
    "nav_bar_config": {
        "nav_bar_menus": [
             {
                "header": "Overviews",
                "entries": [
                    {
                        "title": "GO molecular function overview",
                        "url": "/browse-curation/fission-yeast-mf-go-slim-terms"
                    },
                    {
                        "title": "GO biological process overview",
                        "url": "/browse-curation/fission-yeast-bp-go-slim-terms"
                    },
                    {
                        "title": "GO cellular component overview",
                        "url": "/browse-curation/fission-yeast-cc-go-slim-terms"
                    },
                    {
                        "title": "Fission yeast phenotype overview",
                        "url": "/browse-curation/fypo-slim"
                    },
                    {
                        "title": "Disease association overview",
                        "url": "/browse-curation/disease-slim"
                    },
                    {
                        "title": "All curated GO-CAM pathways",
                        "url": "/documentation/go-cam-pathway-models"
                    },
                    {
                        "title": "Drugs with known S. pombe targets",
                        "url": "/browse-curation/drugs-known-pombe-targets"
                    },
                    {
                        "title": "DNA binding site consensus sequences",
                        "url": "/browse-curation/dna-binding-sites"
                    },
                    {
                        "title": "Known/unknown protein roles",
                        "url": "/status/protein-status-tracker"
                    },
                    {
                        "title": "Genome overview",
                        "url": "/status/genome-overview"
                    }
                ]
            },
            {
                "header": "Status",
                "entries": [
                    {
                        "title": "Genome status index",
                        "url": "/status"
                    },
                    {
                        "title": "Genome statistics",
                        "url": "/status/genome-overview"
                    },
                    {
                        "title": "Non-gene features",
                        "url": "/documentation/non-gene-features"
                    },
                    {
                        "title": "Reference genome status",
                        "url": "/status/sequencing-status"
                    },
                    {
                        "title": "Genome updates",
                        "url": "/status/sequencing-updates"
                    },
                    {
                        "title": "Proten coding gene coordinate changes",
                        "url": "/status/gene-coordinate-changes-protein-coding"
                    },
                    {
                        "title": "RNA gene coordinate changes",
                        "url": "/status/gene-coordinate-changes-RNA"
                    },
                    {
                        "title": "New and removed genes",
                        "url": "/status/new-and-removed-genes"
                    },
                    {
                        "title": "Known/unknown protein roles",
                        "url": "/status/protein-status-tracker"
                    },
                    {
                        "title": "Priority unstudied genes",
                        "url": "/status/priority-unstudied-genes"
                    }
                ]
            },
            {
                "header": "Downloads",
                "entries": [
                    {
                        "title": "All datasets",
                        "url": "/datasets"
                    },
                    {
                        "title": "Latest monthly release",
                        "url": "https://www.pombase.org/latest_release"
                    },
                    {
                        "title": "PomBase user API",
                        "url": "/documentation/api"
                    },
                    {
                        "title": "GO annotation",
                        "url": "/downloads/go-annotations"
                    },
                    {
                        "title": "Phenotype annotation",
                        "url": "/downloads/phenotype-annotations"
                    },
                    {
                        "title": "Protein datasets",
                        "url": "/downloads/protein-datasets"
                    },
                    {
                        "title": "Chado database dumps",
                        "url": "/downloads/chado-database-dumps"
                    }
                ]
            },
            {
                "header": "Community",
                "entries": [
                    {
                        "title": "Mailing list",
                        "url": "https://lists.cam.ac.uk/sympa/info/ucam-pombelist"
                    },
                    {
                        "title": "Community curation project",
                        "url": "/community/fission-yeast-community-curation-project"
                    },
                    {
                        "title": "News archive",
                        "url": "/news"
                    },
                    {
                        "title": "Fission yeast community",
                        "url": "/community"
                    },
                    {
                        "title": "User feedback",
                        "url": "/about/user-feedback"
                    },
                    {
                        "title": "pombeTalks seminars",
                        "url": "/community/pombetalks"
                    },
                    {
                        "title": "Community curated publications",
                        "url": "/reference_list/community"
                    },
                    {
                        "title": "External resources",
                        "url": "/community/internet-resources"
                    }
                ]
            },
            {
                "header": "About",
                "entries": [
                    {
                        "title": "About PomBase",
                        "url": "/about"
                    },
                    {
                        "title": "Citing PomBase",
                        "url": "/about/citing-pombase"
                    },
                    {
                        "title": "Getting started",
                        "url": "/documentation/getting-started"
                    },
                    {
                        "title": "PomBase publications",
                        "url": "/about/pombase-and-collaborative-publications"
                    },
                    {
                        "title": "Scientific Advisory Board",
                        "url": "/about/pombase-sab"
                    },
                    {
                        "title": "Collaborations",
                        "url": "/about/collaborations"
                    },
                    {
                        "title": "Literature and curation metrics",
                        "url": "/metrics"
                    },
                    {
                        "title": "GO-CAM pathway metrics",
                        "url": "/gocam/pathway-metrics"
                    },
                    {
                        "title": "Community curation stats",
                        "url": "https://curation.pombase.org/pombe/stats/annotation"
                    },
                    {
                        "title": "Terms of use",
                        "url": "/about/terms-of-use"
                    }
                ]
            }
        ]
    },
    "sequence_feature_page": {
        "so_types_to_show": [
            "regional_centromere",
            "regional_centromere_central_core"
        ]
    },
    "default_jbrowse_tracks": [
        {
            "pmed_id": "PMID:11859360",
            "label": "DNA sequence"
        },
        {
            "pmed_id": "PMID:11859360",
            "label": "Forward strand features"
        },
        {
            "pmed_id": "PMID:11859360",
            "label": "Reverse strand features"
        }
    ],
    "reference_page_extra_links": {
        "PMID:25373780": [
            {
                "link": "https://idr.openmicroscopy.org/webclient/?show=screen-3",
                "text": "Access the microscopy data in Image Data Resource."
            }
        ],
        "PMID:36257942": [
            {
                "link": "https://butterlab.imb-mainz.de/SpProtQuant/",
                "text": "View the changes in proteome resulting from deleting a certain coding gene, or the changes in protein levels of a given coding gene in all strains deleted for coding genes."
            }
        ],
        "PMID:31364709": [
            {
                "link": "https://www.pombase.org/jbrowse/?loc=mitochondrial%3A1..19433",
                "text": "View the mitochondrial chromosome sequence in the PomBase genome browser ..."
            }
        ],
        "PMID:34296454": [
            {
                "link": "https://tmak.shinyapps.io/TM_App-Table_EV3/",
                "text": "Time-dependent changes can be viewed using the accompanying application"
            }
        ],
        "PMID:34017941":   [
            {
                "link": "https://data.caltech.edu/records/tfcg1-zdc84",
                "text": "Mitochondrial variant calls for all samples used in the study (vcf format)"
            },
            {
                "link": "https://data.caltech.edu/records/4grkw-d1474",
                "text": "Genotype information and meta-data for all samples used in the study (csv format)"
            }
        ],
        "PMID:37991801": [
            {
                "link": "https://www.addgene.org/kits/pluskal-pombox/",
                "text": "addgene page to order POMBOX cloning kit"
            }
        ],
        "PMID:40015273": [
            {
                "link": "https://data.fmi.ch/TFexplorer/",
                "text": "TF Explorer - an interactive web application to explore experimentally determined transcription factor (TF) interactions"
            },
            {
                "link": "https://yeast.nig.ac.jp/yeast/fy/StrainSetIndividualList.jsf?id=8",
                "text": "Obtain strain library from the National BioResource Project (Yeast)"
            },
            {
                "link": "https://www.ncbi.nlm.nih.gov/geo/query/acc.cgi?acc=GSE274238",
                "text": "Genome browser track data in the Gene Expression Omnibus (GEO)"
            }
        ],
        "PMID:39094570": [
            {
                "link": "https://modelarchive.org/doi/10.5452/ma-dm-hisrep",
                "text": "AlphaFold-Multimer predictions of protein-protein interactions"
            }
        ],
        "PMID:25002536": [
            {
                "link": "https://www.ebi.ac.uk/biostudies/ArrayExpress/studies/E-MTAB-2543?query=E-MTAB-2543",
                "text": "Expression profiling for several gene deletion and overexpression strains by microarray assay"
            }
        ],
        "PMID:26697368": [
            {
                "link": "https://www.ncbi.nlm.nih.gov/geo/query/acc.cgi?acc=GSE71820",
                "text": "Gene expression profiling in Atf1 overexpression strain by microarray assay"
            }
        ],
        "PMID:17868468": [
            {
                "link": "https://www.ncbi.nlm.nih.gov/geo/query/acc.cgi?acc=GSE5941",
                "text": "Gene expression profiling in Pog1 mutant strains by microarray assay"
            }
        ],
        "PMID:42562571": [
            {
                "link": "https://www.japonicusdb.org/reference/PMID:42562571",
                "text": "View the <i>S. japonicus</i> annotations for this publication in JaponicusDB"
            }
        ]
    },
    "reference_page_jbrowse_columns": [
        {
            "name": "label",
            "display_name": "Label"
        },
        {
            "name": "growth_phase_or_response",
            "display_name": "Growth phase or response"
        },
        {
            "name": "assayed_gene_product",
            "display_name": "Localized gene product"
        },
        {
            "name": "background",
            "display_name": "Background"
        },
        {
            "name": "mating_type",
            "display_name": "Mating type"
        },
        {
            "name": "conditions",
            "display_name": "Conditions"
        },
        {
            "name": "assay_type",
            "display_name": "Assay type"
        },
        {
            "name": "data_type",
            "display_name": "Data type"
        },
        {
            "name": "alleles",
            "display_name": "WT or mutant"
        },
        {
            "name": "mutants",
            "display_name": "Mutant(s)"
        },
        {
            "name": "comment",
            "display_name": "Comment"
        },
        {
            "name": "source_url",
            "display_name": "",
            "download_link": true
        }
    ],
    "gene_page_extra_links": {},
    "feature_location_warnings": [
        {
            "feature_types": ["lncRNA", "sncRNA"],
            "warning": "Many lncRNAs are cryptic and the functions (if any) are mostly unknown. RNA-seq cannot precisely map transcription start and termination sites, hence features are currently approximate. Most lncRNAs in fission yeast are induced in certain conditions, like non-dividing cells and meiotic differentiation. In proliferating cells, most lncRNAs are suppressed by RNA-processing pathways. For more details on the relevance of a specific RNA please follow the link to the source(s) (adjacent). You can also inspect individual datasets as tracks in JBrowse."
        }
    ],
    "alphafold_max_protein_length": 2700,
    "jbrowse_track_picker_base_url": "/jbrowse/?loc=I:1..5579133",
    "jbrowse2_assembly_name": "pombe_v1",
    "jbrowse2_default_track_ids": ["Schizosaccharomyces_pombe_all_chromosomes_forward_strand", "Schizosaccharomyces_pombe_all_chromosomes_reverse_strand"],
    "search_box_cv_names": [
        "fission_yeast_phenotype",
        "sequence",
        "mondo"
    ],
    "go_cv_names": [
        "molecular_function",
        "biological_process",
        "cellular_component"
    ],
    "search_box_config": {
        "suffixes_to_trim": [
            "\\\\.1",
            "\\\\.1:pep"
        ],
        "ortholog_organisms_to_always_show": [4932, 9606]
    },
    "feature_sub_groups": {
        "rRNA gene": [
            "ncRNA gene"
        ],
        "tRNA gene": [
            "ncRNA gene"
        ],
        "snRNA gene": [
            "ncRNA gene"
        ],
        "snoRNA gene": [
            "ncRNA gene"
        ],
        "lncRNA gene": [
            "ncRNA gene"
        ],
        "sncRNA gene": [
            "ncRNA gene"
        ]
    },
    "query_builder": {
        "node_types": [
            {
                "id": "canned_queries",
                "displayName": "Commonly used queries",
                "nodeType": "sub-nodes",
                "topDescription": [
                    {
                        "text": "Shortcuts for commonly used queries"
                    }
                ],
                "subNodes": [
                    {
                        "id": "canned_queries_gene_number",
                        "displayName": "Gene number",
                        "nodeType": "canned-queries",
                        "query_ids": [
                            "all_protein_coding_ex_dubious_and_transposon",
                            "all_genes"
                        ]
                    },
                    {
                        "id": "canned_queries_viability",
                        "displayName": "Viability",
                        "nodeType": "canned-queries",
                        "query_ids": [
                            "viable_deletions", "inviable_deletions"
                        ]
                    },
                    {
                        "id": "canned_queries_homology_and_disease",
                        "displayName": "Homology and Disease queries",
                        "nodeType": "canned-queries",
                        "query_ids": [
                            "conserved_in_S_cerevisiae", "conserved_in_human",
                            "conserved_in_S_japonicus", "genes_with_paralogs",
                            "all_diseases"
                        ]
                    },
                    {
                        "id": "canned_queries_go_status",
                        "displayName": "GO status queries",
                        "nodeType": "canned-queries",
                        "query_ids": [
                            "protein_coding_genes_unknown_process",
                            "priority-unstudied-genes:conserved_unknown_AND_conserved_in_vertebrates",
                            "canned_query:coding_genes_with_mf_annotation",
                            "canned_query:coding_genes_with_bp_annotation"
                        ]
                    },
                    {
                        "id": "other_popular_gene_lists",
                        "displayName": "Other popular gene lists",
                        "nodeType": "canned-queries",
                        "query_ids": [
                            "genes_with_rna_levels_increased_during_cesr",
                            "genes_with_rna_levels_decreased_during_cesr",
                            "proteins_with_pdb_structures",
                            "genes_with_rna_secondary_structure_predictions",
                            "canned_query:proteins_in_complexes",
                            "canned_query:genes_in_complexes",
                            "gocam_activity_gene_count",
                            "genes_with_annotated_protein_feature",
                            "genes_with_tm_domain_from_deeptmhmm",
                            "genes_with_signal_peptide"
                        ]
                    }
                ]
            },
            {
                "id": "gene_list_queries",
                "displayName": "Gene list queries",
                "nodeType": "heading",
                "topDescription": [],
                "subNodes": [
                    {
                        "id": "gene_list",
                        "displayName": "Gene name and IDs",
                        "nodeType": "gene-list",
                        "topDescription": [
                            {
                                "text": "Enter or upload a list of systematic gene IDs or gene names"
                            }
                        ]
                    },
                    {
                        "id": "uniprot_id_list",
                        "displayName": "UniProt accessions",
                        "nodeType": "gene-list",
                        "topDescription": [
                            {
                                "text": "UniProt accession mapping has moved"
                            }
                        ],
                        "extraResultTableColumns": [
                            "uniprot_identifier"
                        ]
                    }
                ]
            },
            {
                "id": "ontology_queries",
                "displayName": "Ontology queries",
                "nodeType": "heading",
                "topDescription": [],
                "subNodes": [
                    {
                        "id": "GO",
                        "displayName": "GO",
                        "nodeType": "ontology",
                        "ontologyName": "GO",
                        "topDescription": [
                            {
                                "text": "Retrieve genes via annotated Gene Ontology terms that describe the activity, process, or location of their products (protein or ncRNA)"
                            }
                        ]
                    },
                    {
                        "id": "FYPO",
                        "displayName": "phenotype",
                        "nodeType": "ontology",
                        "ontologyName": "FYPO",
                        "annotationFeatureType": "genotype",
                        "topDescription": [
                            {
                                "text": "Retrieve genes based on mutant phenotypes annotated using Fission Yeast Phenotype Ontology (FYPO)"
                            }
                        ],
                        "phenotypeConditionNamespace": "fission_yeast_phenotype_condition"
                    },
                    {
                        "id": "disease_associated",
                        "displayName": "disease association",
                        "nodeType": "ontology",
                        "ontologyName": "mondo",
                        "topDescription": [
                            {
                                "text": "Retrieve genes for which the curated human ortholog is associated with a disease. To find all disease gene orthologs, search for \"disease\""
                            }
                        ]
                    }
                ]
            },
            {
                "id": "gene_product_queries",
                "displayName": "Gene product queries",
                "nodeType": "heading",
                "topDescription": [],
                "subNodes": [
                    {
                        "id": "product_type",
                        "displayName": "product type",
                        "nodeType": "subset-select",
                        "subsets": [
                            {
                                "name": "feature_type_mRNA_gene",
                                "displayName": "feature_type:protein"
                            },
                            {
                                "name": "feature_type_pseudogene",
                                "displayName": "feature_type:pseudogene"
                            },
                            {
                                "name": "feature_type_ncRNA_gene",
                                "displayName": "feature_type:ncRNA (all non coding)"
                            },
                            {
                                "name": "feature_type_lncRNA_gene",
                                "displayName": "feature_type:lncRNA"
                            },
                            {
                                "name": "feature_type_rRNA_gene",
                                "displayName": "feature_type:rRNA"
                            },
                            {
                                "name": "feature_type_snRNA_gene",
                                "displayName": "feature_type:snRNA"
                            },
                            {
                                "name": "feature_type_sncRNA_gene",
                                "displayName": "feature_type:sncRNA"
                            },
                            {
                                "name": "feature_type_snoRNA_gene",
                                "displayName": "feature_type:snoRNA"
                            },
                            {
                                "name": "feature_type_tRNA_gene",
                                "displayName": "feature_type:tRNA"
                            }
                        ],
                        "topDescription": [
                            {
                                "text": "Retrieve genes based on product type. Note that \"protein\" includes dubious and transposon protein-coding genes; there is a prepared query that excludes both in the list of commonly used queries"
                            }
                        ]
                    },
                    {
                        "id": "PSI-MOD",
                        "displayName": "protein modification",
                        "nodeType": "ontology",
                        "ontologyName": "PSI-MOD",
                        "placeholder": "e.g phosphorylated residue (MOD:00696)",
                        "topDescription": [
                            {
                                "text": "Retrieve protein-coding genes based on modifications annotated using PSI-MOD ontology terms"
                            }
                        ]
                    },
                    {
                        "id": "domains_and_features",
                        "displayName": "domain, features and motifs",
                        "nodeType": "sub-nodes",
                        "topDescription": [
                            {
                                "text": "Retrieve protein domains, features and motifs"
                            }
                        ],
                        "subNodes": [
                            {
                                "id": "SO_protein",
                                "displayName": "protein features",
                                "nodeType": "ontology",
                                "ontologyName": "SO-protein",
                                "topDescription": [
                                    {
                                        "text": "Retrieve protein-coding genes based on features annotated using the protein sequence feature branch of the Sequence Ontology (SO)"
                                    }
                                ],
                                "extraDescription": "Examples: short motifs such as NLS or KEN box, signal peptide, mitochondrial targeting signal, cleaved region",
                                "extraDescription2": "Use \"sequence feature\" to retrieve all genes with annotated sequence features"
                            },
                            {
                                "id": "all_domains",
                                "displayName": "Domain ID",
                                "nodeType": "subset-input",
                                "subsetPrefix": null,
                                "placeholder": "eg. PF02373 or IPR001138",
                                "topDescription": [
                                    {
                                        "text": "Retrieve protein-coding genes by specific domains present in the products. To retrieve all domain-containing proteins, search for \"IPR*\" or \"PF*\""
                                    }
                                ]
                            },
                            {
                                "id": "tm_domain_count",
                                "displayName": "TM domains (TMHMM)",
                                "nodeType": "int-range",
                                "range_minimum": 0,
                                "range_any_and_none": true,
                                "topDescription": [
                                    {
                                        "text": "Retrieve protein-coding genes by number of transmembrane domains in the product as predicted by <a href='https://services.healthtech.dtu.dk/services/TMHMM-2.0/'>TMHMM</a>"
                                    }
                                ]
                            },
                            {
                                "id": "deeptmhmm_domain_count",
                                "displayName": "TM domains (DeepTMHMM)",
                                "nodeType": "int-range",
                                "range_minimum": 0,
                                "range_any_and_none": true,
                                "topDescription": [
                                    {
                                        "text": "Retrieve protein-coding genes by number of transmembrane domains in the product as predicted by <a href='https://services.healthtech.dtu.dk/services/DeepTMHMM-1.0/'>DeepTMHMM</a>"
                                    }
                                ]
                            },
                            {
                                "id": "coiled_coils_count",
                                "displayName": "coiled-coil regions",
                                "nodeType": "int-range",
                                "range_minimum": 0,
                                "range_any_and_none": true,
                                "percent_query_id": "coiled_coils_percent",
                                "percent_display_name": "percentage of residues in coiled coil regions",
                                "topDescription": [
                                    {
                                        "text": "Retrieve protein-coding genes by number of predicted coiled-coil domains in the product or by percentage of residues in coiled-coil regions"
                                    }
                                ]
                            },
                            {
                                "id": "disordered_regions_count",
                                "displayName": "disordered regions",
                                "nodeType": "int-range",
                                "range_minimum": 0,
                                "range_any_and_none": true,
                                "percent_query_id": "disordered_percent",
                                "percent_display_name": "percentage of residues in disordered regions",
                                "topDescription": [
                                    {
                                        "text": "Retrieve protein-coding genes by number of disordered regions in the product or by percentage of residues in disordered regions"
                                    }
                                ]
                            },
                            {
                                "id": "low_complexity_regions_count",
                                "displayName": "low complexity regions",
                                "nodeType": "int-range",
                                "range_minimum": 0,
                                "range_any_and_none": true,
                                "percent_query_id": "low_complexity_percent",
                                "percent_display_name": "percentage of residues in low complexity regions",
                                "topDescription": [
                                    {
                                        "text": "Retrieve protein-coding genes by number of low complexity regions in the product or by percentage of residues in low complexity regions"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "protein_properties",
                        "displayName": "protein properties",
                        "nodeType": "sub-nodes",
                        "subsetPrefix": null,
                        "topDescription": [
                            {
                                "text": "Retrieve protein properties"
                            }
                        ],
                        "subNodes": [
                            {
                                "id": "protein_length",
                                "displayName": "protein length",
                                "nodeType": "int-range",
                                "range_minimum": 1,
                                "range_any_and_none": false,
                                "topDescription": [
                                    {
                                        "text": "Retrieve protein-coding genes by product length (in amino acids)"
                                    }
                                ]
                            },
                            {
                                "id": "protein_mol_weight",
                                "displayName": "protein mol. weight",
                                "nodeType": "float-range",
                                "topDescription": [
                                    {
                                        "text": "Retrieve protein-coding genes by product molecular weight in kDa"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "transcript_structure_properties",
                        "displayName": "Transcripts and exons",
                        "nodeType": "sub-nodes",
                        "subsetPrefix": null,
                        "topDescription": [
                            {
                                "text": "Transcript and exons properties"
                            }
                        ],
                        "subNodes": [
                            {
                                "id": "exon_count",
                                "displayName": "number of exons",
                                "nodeType": "int-range",
                                "range_minimum": 1,
                                "range_any_and_none": false,
                                "topDescription": [
                                    {
                                        "text": "Retrieve genes by number of exons in the primary transcript"
                                    }
                                ],
                                "node_options_title": "Consider only",
                                "node_options": [
                                    {
                                        "display_name": "coding exons",
                                        "id": "coding-exons"
                                    },
                                    {
                                        "display_name": "5' UTR exons",
                                        "id": "five-prime-utr-exons"
                                    },
                                    {
                                        "display_name": "3' UTR exons",
                                        "id": "three-prime-utr-exons"
                                    }
                                ]
                            },
                            {
                                "id": "transcript_count",
                                "displayName": "Number of transcripts",
                                "nodeType": "int-range",
                                "range_minimum": 1,
                                "range_any_and_none": false,
                                "topDescription": [
                                    {
                                        "text": "Retrieve genes by number of transcript isoforms"
                                    }
                                ]
                            },
                            {
                                "id": "spliced_rna_length",
                                "displayName": "Spliced RNA length",
                                "nodeType": "int-range",
                                "range_minimum": 1,
                                "range_any_and_none": false,
                                "topDescription": [
                                    {
                                        "text": "Retrieve genes by spliced RNA length in nucleotides (not including UTRs for protein coding genes)"
                                    }
                                ]
                            },
                            {
                                "id": "unspliced_rna_length",
                                "displayName": "Unspliced RNA length",
                                "nodeType": "int-range",
                                "range_minimum": 1,
                                "range_any_and_none": false,
                                "topDescription": [
                                    {
                                        "text": "Retrieve genes by un-spliced RNA length in nucleotides (not including UTRs for protein coding genes)"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "id": "genome_overview_queries",
                "displayName": "Genome overview queries",
                "nodeType": "heading",
                "subNodes": [
                    {
                        "id": "genome_range",
                        "displayName": "Genome location",
                        "nodeType": "genome-range",
                        "topDescription": [
                            {
                                "text": "Retrieve genes in a specified region of a chromosome"
                            }
                        ]
                    },
                    {
                        "id": "orthologs-and-conservation",
                        "nodeType": "sub-nodes",
                        "displayName": "Orthologs and conservation",
                        "topDescription": [
                            {
                                "text": "Orthologs and conservation"
                            }
                        ],
                        "subNodes": [
                            {
                                "id": "taxonomic_conservation",
                                "displayName": "taxonomic conservation",
                                "nodeType": "small-ontology",
                                "terms": [
                                    {
                                        "name": "Schizosaccharomyces pombe specific",
                                        "termid": "PBO:0016878"
                                    },
                                    {
                                        "name": "Schizosaccharomyces specific",
                                        "termid": "PBO:0016885"
                                    },
                                    {
                                        "name": "conserved in archaea",
                                        "termid": "PBO:0011072"
                                    },
                                    {
                                        "name": "conserved in bacteria",
                                        "termid": "PBO:0011067"
                                    },
                                    {
                                        "name": "conserved in eukaryotes",
                                        "termid": "PBO:0011065"
                                    },
                                    {
                                        "name": "conserved in eukaryotes only",
                                        "termid": "PBO:0011071"
                                    },
                                    {
                                        "name": "conserved in fungi",
                                        "termid": "PBO:0011064"
                                    },
                                    {
                                        "name": "conserved in fungi only",
                                        "termid": "PBO:0011063"
                                    },
                                    {
                                        "name": "conserved in metazoa",
                                        "termid": "PBO:0011069"
                                    },
                                    {
                                        "name": "conserved in vertebrates",
                                        "termid": "PBO:0011070"
                                    },
                                    {
                                        "name": "faster evolving duplicate",
                                        "termid": "PBO:0009798"
                                    },
                                    {
                                        "name": "no apparent S. cerevisiae ortholog",
                                        "termid": "PBO:0000055"
                                    },
                                    {
                                        "name": "orthologs cannot be distinguished",
                                        "termid": "PBO:0000110"
                                    },
                                    {
                                        "name": "predominantly single copy (one to one)",
                                        "termid": "PBO:0006222"
                                    }
                                ],
                                "topDescription": [
                                    {
                                        "text": "Retrieve protein-coding genes based on broad categories of taxonomic conservation"
                                    }
                                ]
                            },
                            {
                                "id": "has_ortholog",
                                "displayName": "protein with orthologs",
                                "nodeType": "has-ortholog",
                                "topDescription": [
                                    {
                                        "text": "Retrieve proteins that have an ortholog in"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "id": "characterisation_status",
                        "displayName": "characterisation status",
                        "nodeType": "subset-select",
                        "subsets": [
                            {
                                "name": "characterisation_status_biological_role_published",
                                "displayName": "characterisation_status:biological role published"
                            },
                            {
                                "name": "characterisation_status_transposon",
                                "displayName": "characterisation_status:transposon"
                            },
                            {
                                "name": "characterisation_status_dubious",
                                "displayName": "characterisation_status:dubious"
                            },
                            {
                                "name": "characterisation_status_Schizosaccharomyces_specific_protein_uncharacterized",
                                "displayName": "characterisation_status:Schizo. specific, uncharacterized"
                            },
                            {
                                "name": "characterisation_status_Schizosaccharomyces_pombe_specific_protein_uncharacterized",
                                "displayName": "characterisation_status:S. pombe specific, uncharacterized"
                            },
                            {
                                "name": "characterisation_status_biological_role_inferred",
                                "displayName": "characterisation_status:biological role inferred"
                            },
                            {
                                "name": "characterisation_status_meiotic_driver",
                                "displayName": "characterisation_status:meiotic driver (selfish genes)"
                            },
                            {
                                "name": "characterisation_status_conserved_unknown",
                                "displayName": "characterisation_status:conserved unknown"
                            }
                        ],
                        "topDescription": [
                            {
                                "text": "Retrieve protein-coding genes based on "
                            },
                            {
                                "link": {
                                    "link_text": "characterisation status",
                                    "route": "/status/protein-status-tracker"
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    },
    "gocams": {
        "max_genes_mega_model_coverage": 3000
    },
    "organisms": [
        {
            "taxonid": 4896,
            "genus": "Schizosaccharomyces",
            "species": "pombe",
            "common_name": "S. pombe",
            "alternative_names": [
                "fission yeast"
            ],
            "assembly_version": "ASM294v2",
            "example_gene_identifiers": [
                "cdc11",
                "SPCC18B5.03"
            ]
        },
        {
            "taxonid": 4932,
            "genus": "Saccharomyces",
            "species": "cerevisiae",
            "alternative_names": [
                "brewer's yeast",
                "baker's yeast",
                "budding yeast"
            ],
            "common_name": "S. cerevisiae",
            "example_gene_identifiers": [
                "CDC28",
                "YBR160W"
            ],
            "database_id_prefix": "SGD"
        },
        {
            "taxonid": 4897,
            "genus": "Schizosaccharomyces",
            "species": "japonicus",
            "alternative_names": [],
            "common_name": "S. japonicus",
            "example_gene_identifiers": [
                " mid1",
                "SJAG_01143"
            ],
            "database_id_prefix": "JaponicusDB"
        },
        {
            "taxonid": 9606,
            "genus": "Homo",
            "species": "sapiens",
            "alternative_names": [],
            "common_name": "human",
            "example_gene_identifiers": [
                "CDK1",
                "HGNC:1722"
            ],
            "database_id_prefix": "HGNC"
        }
    ],
    "ortholog_taxonids": [
        4932,
        4897,
        9606
    ],
    "predefined_queries": {
        "priority-unstudied-genes:unknown_genes": {
            "constraints": {
                "or": [
                    {
                        "subset": {
                            "subset_name": "characterisation_status_Schizosaccharomyces_pombe_specific_protein_uncharacterized"
                        }
                    },
                    {
                        "subset": {
                            "subset_name": "characterisation_status_Schizosaccharomyces_specific_protein_uncharacterized"
                        }
                    },
                    {
                        "subset": {
                            "subset_name": "characterisation_status_conserved_unknown"
                        }
                    }
                ]
            }
        },
        "priority-unstudied-genes:conserved_unknown": {
            "name": "Genes of unknown process, conserved outside the Schizosaccharomyces clade",
            "constraints": {
                "subset": {
                    "subset_name": "characterisation_status_conserved_unknown"
                }
            }
        },
        "priority-unstudied-genes:conserved_unknown_AND_conserved_in_vertebrates": {
            "name": "Priority unstudied genes (vertebrate orthologs, unknown process, protein coding)",
            "constraints": {
                "and": [
                    {
                        "term": {
                            "termid": "PBO:0011070",
                            "name": "conserved in vertebrates",
                            "single_or_multi_locus": null,
                            "expression": null
                        }
                    },
                    {
                        "subset": {
                            "subset_name": "characterisation_status_conserved_unknown"
                        }
                    }
                ]
            }
        },
        "mitochondrial_genes": {
            "name": "Mitochondrial genes",
            "constraints": {
                "and": [
                    {
                        "not": [
                            {
                                "not": [
                                    {
                                        "node_name": "subset: feature_type_mRNA_gene",
                                        "subset": {
                                            "subset_name": "feature_type_mRNA_gene"
                                        }
                                    },
                                    {
                                        "node_name": "subset: characterisation_status_transposon",
                                        "subset": {
                                            "subset_name": "characterisation_status_transposon"
                                        }
                                    }
                                ],
                                "node_name": "subset: feature_type_mRNA_gene NOT subset: characterisation_status_transposon"
                            },
                            {
                                "node_name": "subset: characterisation_status_dubious",
                                "subset": {
                                    "subset_name": "characterisation_status_dubious"
                                }
                            }
                        ],
                        "node_name": "All protein coding genes (excluding dubious and transposon)"
                    },
                    {
                        "node_name": "genes annotated with \"mitochondrion\" (GO:0005739)",
                        "term": {
                            "termid": "GO:0005739",
                            "name": "mitochondrion",
                            "ploidiness": null,
                            "expression": null
                        }
                    }
                ],
                "node_name": "(All protein coding genes (excluding dubious and transposon)) AND genes annotated with \"mitochondrion\" (GO:0005739)"
            },
            "output_options": {}
        }
,
        "gocam_modelled_mitochondrial_genes": {
            "name": "GO-CAM modelled mitochondrial genes",
            "constraints": {
                "and": [
                    {
                        "and": [
                            {
                                "not": [
                                    {
                                        "not": [
                                            {
                                                "node_name": "subset: feature_type_mRNA_gene",
                                                "subset": {
                                                    "subset_name": "feature_type_mRNA_gene"
                                                }
                                            },
                                            {
                                                "node_name": "subset: characterisation_status_transposon",
                                                "subset": {
                                                    "subset_name": "characterisation_status_transposon"
                                                }
                                            }
                                        ],
                                        "node_name": "subset: feature_type_mRNA_gene NOT subset: characterisation_status_transposon"
                                    },
                                    {
                                        "node_name": "subset: characterisation_status_dubious",
                                        "subset": {
                                            "subset_name": "characterisation_status_dubious"
                                        }
                                    }
                                ],
                                "node_name": "All protein coding genes (excluding dubious and transposon)"
                            },
                            {
                                "node_name": "genes annotated with \"mitochondrion\" (GO:0005739)",
                                "term": {
                                    "termid": "GO:0005739",
                                    "name": "mitochondrion",
                                    "ploidiness": null,
                                    "expression": null
                                }
                            }
                        ],
                        "node_name": "(All protein coding genes (excluding dubious and transposon)) AND genes annotated with \"mitochondrion\" (GO:0005739)"
                    },
                    {
                        "node_name": "Genes that enable activities in GO-CAM pathway models",
                        "int_range": {
                            "range_type": "gocam_activity_gene_count",
                            "start": 1,
                            "end": null
                        }
                    }
                ],
                "node_name": "Genes that enable activities in GO-CAM pathway models AND ((All protein coding genes (excluding dubious and transposon)) AND genes annotated with \"mitochondrion\" (GO:0005739))"
            },
            "output_options": {}
        },
        "central_metabolism_genes": {
            "name": "Central metabolism genes",
            "constraints": {
                "or": [
                    {
                        "node_name": "genes annotated with \"lipid metabolic process\" (GO:0006629)",
                        "term": {
                            "termid": "GO:0006629",
                            "name": "lipid metabolic process",
                            "ploidiness": null,
                            "expression": null
                        }
                    },
                    {
                        "node_name": "genes annotated with \"small molecule metabolic process\" (GO:0044281)",
                        "term": {
                            "termid": "GO:0044281",
                            "name": "small molecule metabolic process",
                            "ploidiness": null,
                            "expression": null
                        }
                    }
                ],
                "node_name": "REFERENCE FOR DOCS genes annotated with \"lipid metabolic process\" (GO:0006629) OR genes annotated with \"small molecule metabolic process\" (GO:0044281)"
            },
            "output_options": {}
        },
        "gocam_modelled_central_metabolism_genes": {
            "name": "GO-CAM modelled central metabolism genes",
            "constraints": {
                "and": [
                    {
                        "or": [
                            {
                                "node_name": "genes annotated with \"lipid metabolic process\" (GO:0006629)",
                                "term": {
                                    "termid": "GO:0006629",
                                    "name": "lipid metabolic process",
                                    "ploidiness": null,
                                    "expression": null
                                }
                            },
                            {
                                "node_name": "genes annotated with \"small molecule metabolic process\" (GO:0044281)",
                                "term": {
                                    "termid": "GO:0044281",
                                    "name": "small molecule metabolic process",
                                    "ploidiness": null,
                                    "expression": null
                                }
                            }
                        ],
                        "node_name": "REFERENCE FOR DOCS genes annotated with \"lipid metabolic process\" (GO:0006629) OR genes annotated with \"small molecule metabolic process\" (GO:0044281)"
                    },
                    {
                        "node_name": "Genes that enable activities in GO-CAM pathway models",
                        "int_range": {
                            "range_type": "gocam_activity_gene_count",
                            "start": 1,
                            "end": null
                        }
                    }
                ],
                "node_name": "Genes that enable activities in GO-CAM pathway models AND (REFERENCE FOR DOCS genes annotated with \"lipid metabolic process\" (GO:0006629) OR genes annotated with \"small molecule metabolic process\" (GO:0044281))"
            },
            "output_options": {}
        },
        "signaling_genes": {
            "name": "Signaling genes",
            "constraints": {
                "node_name": "genes annotated with \"signaling\" (GO:0023052)",
                "term": {
                    "termid": "GO:0023052",
                    "name": "signaling",
                    "ploidiness": null,
                    "expression": null
                }
            },
            "output_options": {}
        },
        "gocam_modelled_signaling_genes": {
            "name": "GO-CAM modelled signaling genes",
            "constraints": {
                "and": [
                    {
                        "node_name": "genes annotated with \"signaling\" (GO:0023052)",
                        "term": {
                            "termid": "GO:0023052",
                            "name": "signaling",
                            "ploidiness": null,
                            "expression": null
                        }
                    },
                    {
                        "node_name": "Genes that enable activities in GO-CAM pathway models",
                        "int_range": {
                            "range_type": "gocam_activity_gene_count",
                            "start": 1,
                            "end": null
                        }
                    }
                ],
                "node_name": "genes annotated with \"signaling\" (GO:0023052) AND Genes that enable activities in GO-CAM pathway models"
            },
            "output_options": {}
        },
        "heterochromatin_genes": {
            "name": "Heterochromatin genes",
            "constraints": {
                "node_name": "genes annotated with \"heterochromatin formation\" (GO:0031507)",
                "term": {
                    "termid": "GO:0031507",
                    "name": "heterochromatin formation",
                    "ploidiness": null,
                    "expression": null
                }
            },
            "output_options": {}
        },
        "gocam_modelled_heterochromatin_genes": {
            "name": "GO-CAM modelled heterochromatin genes",
            "constraints": {
                "and": [
                    {
                        "node_name": "genes annotated with \"heterochromatin formation\" (GO:0031507)",
                        "term": {
                            "termid": "GO:0031507",
                            "name": "heterochromatin formation",
                            "ploidiness": null,
                            "expression": null
                        }
                    },
                    {
                        "node_name": "Genes that enable activities in GO-CAM pathway models",
                        "int_range": {
                            "range_type": "gocam_activity_gene_count",
                            "start": 1,
                            "end": null
                        }
                    }
                ],
                "node_name": "genes annotated with \"heterochromatin formation\" (GO:0031507) AND Genes that enable activities in GO-CAM pathway models"
            },
            "output_options": {}
        },
        "canned_query:all_diseases": {
            "name": "All disease associated genes",
            "constraints": {
                "or": [
                    {
                        "node_name": "genes annotated with \"disease susceptibility\" (MONDO:0042489)",
                        "term": {
                            "termid": "MONDO:0042489",
                            "name": "disease susceptibility",
                            "ploidiness": null,
                            "expression": null
                        }
                    },
                    {
                        "node_name": "genes annotated with \"disease\" (MONDO:0000001)",
                        "term": {
                            "termid": "MONDO:0000001",
                            "name": "disease",
                            "ploidiness": null,
                            "expression": null
                        }
                    }
                ],
                "node_name": "genes annotated with \"disease\" (MONDO:0000001) OR genes annotated with \"disease susceptibility\" (MONDO:0042489)"
            }
        },
        "canned_query:all_protein_coding_ex_dubious_and_transposon": {
            "name": "All protein coding genes (excluding dubious and transposon)",
            "constraints": {
                "not": [
                    {
                        "not": [
                            {
                                "subset": {
                                    "subset_name": "feature_type_mRNA_gene"
                                }
                            },
                            {
                                "subset": {
                                    "subset_name": "characterisation_status_transposon"
                                }
                            }
                        ]
                    },
                    {
                        "subset": {
                            "subset_name": "characterisation_status_dubious"
                        }
                    }
                ]
            }
        },
        "canned_query:protein_coding_genes_unknown_process": {
            "name": "Protein coding genes, unknown process",
            "constraints": {
                "or": [
                    {
                        "subset": {
                            "subset_name": "characterisation_status_conserved_unknown"
                        }
                    },
                    {
                        "subset": {
                            "subset_name": "characterisation_status_Schizosaccharomyces_pombe_specific_protein_uncharacterized"
                        }
                    },
                    {
                        "subset": {
                            "subset_name": "characterisation_status_Schizosaccharomyces_specific_protein_uncharacterized"
                        }
                    }
                ]
            }
        },
        "canned_query:proteins_of_unknown_molecular_function": {
            "name": "Proteins of unknown molecular function",
            "constraints": {
                "not": [
                    {
                        "not": [
                            {
                                "not": [
                                    {
                                        "not": [
                                            {
                                                "node_name": "subset: feature_type_mRNA_gene",
                                                "subset": {
                                                    "subset_name": "feature_type_mRNA_gene"
                                                }
                                            },
                                            {
                                                "node_name": "subset: characterisation_status_transposon",
                                                "subset": {
                                                    "subset_name": "characterisation_status_transposon"
                                                }
                                            }
                                        ],
                                        "node_name": "subset: feature_type_mRNA_gene NOT subset: characterisation_status_transposon"
                                    },
                                    {
                                        "node_name": "subset: characterisation_status_dubious",
                                        "subset": {
                                            "subset_name": "characterisation_status_dubious"
                                        }
                                    }
                                ],
                                "node_name": "All protein coding genes (excluding dubious and transposon)"
                            },
                            {
                                "node_name": "genes annotated with \"molecular_function\" (GO:0003674)",
                                "term": {
                                    "termid": "GO:0003674",
                                    "name": "molecular_function",
                                    "ploidiness": null,
                                    "expression": null
                                }
                            }
                        ],
                        "node_name": "(All protein coding genes (excluding dubious and transposon)) NOT genes annotated with \"molecular_function\" (GO:0003674)"
                    },
                    {
                        "not": [
                            {
                                "node_name": "subset: characterisation_status_meiotic_driver",
                                "subset": {
                                    "subset_name": "characterisation_status_meiotic_driver"
                                }
                            },
                            {
                                "or": [
                                    {
                                        "node_name": "subset: characterisation_status_conserved_unknown",
                                        "subset": {
                                            "subset_name": "characterisation_status_conserved_unknown"
                                        }
                                    },
                                    {
                                        "node_name": "subset: characterisation_status_Schizosaccharomyces_pombe_specific_protein_uncharacterized",
                                        "subset": {
                                            "subset_name": "characterisation_status_Schizosaccharomyces_pombe_specific_protein_uncharacterized"
                                        }
                                    },
                                    {
                                        "node_name": "subset: characterisation_status_Schizosaccharomyces_specific_protein_uncharacterized",
                                        "subset": {
                                            "subset_name": "characterisation_status_Schizosaccharomyces_specific_protein_uncharacterized"
                                        }
                                    }
                                ],
                                "node_name": "Protein coding genes, unknown process"
                            }
                        ],
                        "node_name": "subset: characterisation_status_meiotic_driver NOT (Protein coding genes, unknown process)"
                    }
                ],
                "node_name": "((All protein coding genes (excluding dubious and transposon)) NOT genes annotated with \"molecular_function\" (GO:0003674)) NOT (subset: characterisation_status_meiotic_driver NOT (Protein coding genes, unknown process))"
            },
            "output_options": {}
        },
        "canned_query:unknown_process_known_function": {
            "constraints": {
                "not": [
                    {
                        "or": [
                            {
                                "node_name": "subset: characterisation_status_conserved_unknown",
                                "subset": {
                                    "subset_name": "characterisation_status_conserved_unknown"
                                }
                            },
                            {
                                "node_name": "subset: characterisation_status_Schizosaccharomyces_pombe_specific_protein_uncharacterized",
                                "subset": {
                                    "subset_name": "characterisation_status_Schizosaccharomyces_pombe_specific_protein_uncharacterized"
                                }
                            },
                            {
                                "node_name": "subset: characterisation_status_Schizosaccharomyces_specific_protein_uncharacterized",
                                "subset": {
                                    "subset_name": "characterisation_status_Schizosaccharomyces_specific_protein_uncharacterized"
                                }
                            }
                        ],
                        "node_name": "Protein coding genes, unknown process"
                    },
                    {
                        "not": [
                            {
                                "not": [
                                    {
                                        "not": [
                                            {
                                                "not": [
                                                    {
                                                        "node_name": "subset: feature_type_mRNA_gene",
                                                        "subset": {
                                                            "subset_name": "feature_type_mRNA_gene"
                                                        }
                                                    },
                                                    {
                                                        "node_name": "subset: characterisation_status_transposon",
                                                        "subset": {
                                                            "subset_name": "characterisation_status_transposon"
                                                        }
                                                    }
                                                ],
                                                "node_name": "subset: feature_type_mRNA_gene NOT subset: characterisation_status_transposon"
                                            },
                                            {
                                                "node_name": "subset: characterisation_status_dubious",
                                                "subset": {
                                                    "subset_name": "characterisation_status_dubious"
                                                }
                                            }
                                        ],
                                        "node_name": "(subset: feature_type_mRNA_gene NOT subset: characterisation_status_transposon) NOT subset: characterisation_status_dubious"
                                    },
                                    {
                                        "node_name": "genes annotated with \"molecular_function\" (GO:0003674)",
                                        "term": {
                                            "termid": "GO:0003674",
                                            "name": "molecular_function",
                                            "ploidiness": null,
                                            "expression": null
                                        }
                                    }
                                ],
                                "node_name": "((subset: feature_type_mRNA_gene NOT subset: characterisation_status_transposon) NOT subset: characterisation_status_dubious) NOT genes annotated with \"molecular_function\" (GO:0003674)"
                            },
                            {
                                "not": [
                                    {
                                        "node_name": "subset: characterisation_status_meiotic_driver",
                                        "subset": {
                                            "subset_name": "characterisation_status_meiotic_driver"
                                        }
                                    },
                                    {
                                        "or": [
                                            {
                                                "node_name": "subset: characterisation_status_conserved_unknown",
                                                "subset": {
                                                    "subset_name": "characterisation_status_conserved_unknown"
                                                }
                                            },
                                            {
                                                "node_name": "subset: characterisation_status_Schizosaccharomyces_pombe_specific_protein_uncharacterized",
                                                "subset": {
                                                    "subset_name": "characterisation_status_Schizosaccharomyces_pombe_specific_protein_uncharacterized"
                                                }
                                            },
                                            {
                                                "node_name": "subset: characterisation_status_Schizosaccharomyces_specific_protein_uncharacterized",
                                                "subset": {
                                                    "subset_name": "characterisation_status_Schizosaccharomyces_specific_protein_uncharacterized"
                                                }
                                            }
                                        ],
                                        "node_name": "subset: characterisation_status_conserved_unknown OR subset: characterisation_status_Schizosaccharomyces_pombe_specific_protein_uncharacterized OR subset: characterisation_status_Schizosaccharomyces_specific_protein_uncharacterized"
                                    }
                                ],
                                "node_name": "subset: characterisation_status_meiotic_driver NOT (subset: characterisation_status_conserved_unknown OR subset: characterisation_status_Schizosaccharomyces_pombe_specific_protein_uncharacterized OR subset: characterisation_status_Schizosaccharomyces_specific_protein_uncharacterized)"
                            }
                        ],
                        "node_name": "Proteins of unknown molecular function"
                    }
                ],
                "node_name": "(Protein coding genes, unknown process) NOT (Proteins of unknown molecular function)"
            },
            "output_options": {}
        },
        "single_allele_chemical_resistance": {
            "name": "chemical resistance (single mutants)",
            "constraints": {
                "term": {
                    "termid": "FYPO:0002682",
                    "name": "increased resistance to chemical",
                    "single_or_multi_locus": "single",
                    "expression": "any"
                }
            }
        },
        "single_allele_chemical_sensitivity": {
            "name": "chemical sensitivity (single mutants)",
            "constraints": {
                "term": {
                    "termid": "FYPO:0002683",
                    "name": "increased sensitivity to chemical",
                    "single_or_multi_locus": "single",
                    "expression": "any"
                }
            }
        },
        "null_inviable": {
            "constraints": {
                "term": {
                    "termid": "FYPO:0002061",
                    "name": "inviable vegetative cell population",
                    "single_or_multi_locus": "single",
                    "expression": "null",
                    "ploidiness": "haploid"
                }
            }
        },
        "null_viable": {
            "constraints": {
                "term": {
                    "termid": "FYPO:0002060",
                    "name": "viable vegetative cell population",
                    "single_or_multi_locus": "single",
                    "expression": "null",
                    "ploidiness": "haploid"
                }
            }
        },
        "null_viable_and_inviable": {
            "constraints": {
                "and": [
                    {
                        "term": {
                            "termid": "FYPO:0002061",
                            "name": "inviable vegetative cell population",
                            "single_or_multi_locus": "single",
                            "expression": "null",
                            "ploidiness": "haploid"
                        }
                    },
                    {
                        "term": {
                            "termid": "FYPO:0002060",
                            "name": "viable vegetative cell population",
                            "single_or_multi_locus": "single",
                            "expression": "null",
                            "ploidiness": "haploid"
                        }
                    }
                ]
            }
        },
        "conserved_in_vertebrates": {
            "name": "conserved in vertebrates",
            "constraints": {
                "term": {
                    "termid": "PBO:0011070",
                    "name": "conserved in vertebrates",
                    "single_or_multi_locus": null,
                    "expression": null
                }
            }
        },
        "GO_976_or_GO_3700": {
            "name": "GO:0000976 or GO:0003700",
            "constraints": {
                "or": [
                    {
                        "term": {
                            "termid": "GO:0003700",
                            "name": "DNA binding transcription factor activity",
                            "single_or_multi_locus": null,
                            "expression": null
                        }
                    },
                    {
                        "term": {
                            "termid": "GO:0000976",
                            "name": "transcription regulatory region sequence-specific DNA binding",
                            "single_or_multi_locus": null,
                            "expression": null
                        }
                    }
                ]
            }
        },
        "GO_978_and_published": {
            "name": "GO:0000978 and published",
            "constraints": {
                "and": [
                    {
                        "term": {
                            "termid": "GO:0000978",
                            "name": "RNA polymerase II proximal promoter sequence-specific DNA binding",
                            "single_or_multi_locus": null,
                            "expression": null
                        }
                    },
                    {
                        "subset": {
                            "subset_name": "characterisation_status_biological_role_published"
                        }
                    }
                ]
            }
        },
        "transposons": {
            "name": "Transposons",
            "constraints": {
                "subset": {
                    "subset_name": "characterisation_status_transposon"
                }
            }
        },
        "canned_query:all_genes": {
            "name": "All genes",
            "constraints": {
                "or": [
                    {
                        "subset": {
                            "subset_name": "feature_type_guide_RNA_gene"
                        }
                    },
                    {
                        "subset": {
                            "subset_name": "feature_type_ncRNA_gene"
                        }
                    },
                    {
                        "subset": {
                            "subset_name": "feature_type_rRNA_gene"
                        }
                    },
                    {
                        "subset": {
                            "subset_name": "feature_type_sncRNA_gene"
                        }
                    },
                    {
                        "subset": {
                            "subset_name": "feature_type_snRNA_gene"
                        }
                    },
                    {
                        "subset": {
                            "subset_name": "feature_type_antisense_RNA_gene"
                        }
                    },
                    {
                        "subset": {
                            "subset_name": "feature_type_pseudogene"
                        }
                    },
                    {
                        "subset": {
                            "subset_name": "feature_type_mRNA_gene"
                        }
                    },
                    {
                        "subset": {
                            "subset_name": "feature_type_snoRNA_gene"
                        }
                    },
                    {
                        "subset": {
                            "subset_name": "feature_type_tRNA_gene"
                        }
                    },
                    {
                        "subset": {
                            "subset_name": "feature_type_lncRNA_gene"
                        }
                    }
                ]
            }
        },
        "2-20_exons": {
            "name": "protein-coding genes with 2-20 exons",
            "constraints": {
                "int_range": {
                    "range_type": "exon_count",
                    "start": 2,
                    "end": 20
                }
            }
        },
        "chr2_1000000-2000000": {
            "name": "genes between coordinates 1000000-2000000 on chromosome 2",
            "constraints": {
                "genome_range": {
                    "start": 1000000,
                    "end": 2000000,
                    "chromosome_name": "chromosome_2"
                }
            }
        },
        "MOD_696": {
            "name": "phosphorylated residue",
            "constraints": {
                "term": {
                    "termid": "MOD:00696",
                    "name": "phosphorylated residue",
                    "single_or_multi_locus": null,
                    "expression": null
                }
            }
        },
        "SO_1528": {
            "name": "nuclear localization signal",
            "constraints": {
                "term": {
                    "termid": "SO:0001528",
                    "name": "nuclear_localization_signal",
                    "single_or_multi_locus": null,
                    "expression": null
                }
            }
        },
        "FYPO_17_all": {
            "name": "elongated cell",
            "constraints": {
                "term": {
                    "termid": "FYPO:0000017",
                    "name": "elongated cell",
                    "single_or_multi_locus": "single",
                    "expression": "any"
                }
            }
        },
        "Pfam_PF00004": {
            "name": "ATPase, AAA-type, core",
            "constraints": {
                "subset": {
                    "subset_name": "PF00004"
                }
            }
        },
        "GO_4721": {
            "name": "phosphoprotein phosphatase activity",
            "constraints": {
                "term": {
                    "termid": "GO:0004721",
                    "name": "phosphoprotein phosphatase activity",
                    "single_or_multi_locus": null,
                    "expression": null
                }
            }
        },
        "GO_5634": {
            "name": "nucleus",
            "constraints": {
                "term": {
                    "termid": "GO:0005634",
                    "name": "nucleus",
                    "single_or_multi_locus": null,
                    "expression": null
                }
            }
        },
        "7TM": {
            "name": "proteins with 7 transmembrane domains",
            "constraints": {
                "int_range": {
                    "range_type": "tm_domain_count",
                    "start": 7,
                    "end": 7
                }
            }
        },
        "rrna_genes": {
            "name": "rRNA genes",
            "constraints": {
                "subset": {
                    "subset_name": "feature_type_rRNA_gene"
                }
            }
        },
        "cancer": {
            "name": "cancer",
            "constraints": {
                "term": {
                    "termid": "MONDO:0004992",
                    "name": "cancer",
                    "single_or_multi_locus": null,
                    "expression": null
                }
            }
        },
        "snorna_genes": {
            "name": "snoRNA genes",
            "constraints": {
                "subset": {
                    "subset_name": "feature_type_snoRNA_gene"
                }
            }
        },
        "FYPO_78_or_GO_45333": {
            "name": "FYPO:0000078 or GO:0045333",
            "constraints": {
                "or": [
                    {
                        "term": {
                            "termid": "FYPO:0000078",
                            "name": "abnormal cellular respiration",
                            "single_or_multi_locus": "single",
                            "expression": "any"
                        }
                    },
                    {
                        "term": {
                            "termid": "GO:0045333",
                            "name": "cellular respiration",
                            "single_or_multi_locus": null,
                            "expression": null
                        }
                    }
                ]
            }
        },
        "canned_query:viable_deletions": {
            "name": "Viable deletions and disruptions",
            "constraints": {
                "term": {
                    "termid": "FYPO:0002060",
                    "name": "viable vegetative cell population",
                    "single_or_multi_locus": "single",
                    "expression": "null",
                    "ploidiness": "haploid"
                }
            }
        },
        "canned_query:inviable_deletions": {
            "name": "Inviable deletions and disruptions",
            "constraints": {
                "term": {
                    "termid": "FYPO:0002061",
                    "name": "inviable vegetative cell population",
                    "single_or_multi_locus": "single",
                    "expression": "null",
                    "ploidiness": "haploid"
                }
            }
        },
        "canned_query:conserved_in_S_cerevisiae": {
            "name": "Proteins conserved in <i>S. cerevisiae</i>",
            "constraints": {
                "and": [
                    {
                        "node_name": "has ortholog with: S. cerevisiae",
                        "has_ortholog": {
                            "taxonid": 4932
                        }
                    },
                    {
                        "node_name": "subset: mRNA genes",
                        "subset": {
                            "subset_name": "feature_type_mRNA_gene"
                        }
                    }
                ]
            }
        },
        "canned_query:conserved_in_vertebrates": {
            "name": "Proteins conserved in human/vertebrates",
            "constraints": {
                "term": {
                    "termid": "PBO:0011070",
                    "name": "conserved in vertebrates",
                    "single_or_multi_locus": null,
                    "expression": null
                }
            }
        },
        "canned_query:conserved_in_human": {
            "name": "Proteins conserved in human",
            "constraints": {
                "and": [
                    {
                        "node_name": "has ortholog with: human",
                        "has_ortholog": {
                            "taxonid": 9606
                        }
                    },
                    {
                        "node_name": "subset: mRNA genes",
                        "subset": {
                            "subset_name": "feature_type_mRNA_gene"
                        }
                    }
                ]
            }
        },
        "canned_query:conserved_in_S_japonicus": {
            "name": "Proteins conserved in <i>S. japonicus</i>",
            "constraints": {
                "and": [
                    {
                        "node_name": "has ortholog with: S. japonicus",
                        "has_ortholog": {
                            "taxonid": 4897
                        }
                    },
                    {
                        "node_name": "subset: mRNA genes",
                        "subset": {
                            "subset_name": "feature_type_mRNA_gene"
                        }
                    }
                ]
            }
        },
        "canned_query:proteins_with_pdb_structures": {
            "name": "Proteins with PDB structures",
            "constraints": {
                "node_name": "pdb_structure_count(≥1)",
                "int_range": {
                    "range_type": "pdb_structure_count",
                    "start": 1,
                    "end": null
                }
            }
        },
        "canned_query:genes_in_gocam_models": {
            "name": "Genes in GO-CAM pathway models (including target genes)",
            "constraints": {
                "node_name": "gocam_model_count(≥1)",
                "int_range": {
                    "range_type": "gocam_model_count",
                    "start": 1,
                    "end": null
                }
            }
        },
        "canned_query:gocam_activity_gene_count": {
            "name": "Genes that enable activities in GO-CAM pathway models",
            "constraints": {
                "node_name": "gocam_activity_gene_count(≥1)",
                "int_range": {
                    "range_type": "gocam_activity_gene_count",
                    "start": 1,
                    "end": null
                }
            }
        },
        "canned_query:genes_with_rna_secondary_structure_predictions": {
            "name": "Genes with RNA secondary structure predictions",
            "constraints": {
                "node_name": "RNA 2D structures",
                "gene_properties": {
                    "property_flags": [
                        "rnacentral_2d_structure"
                    ]
                }
            }
        },
        "canned_query:genes_with_paralogs": {
            "name": "Genes with paralogs",
            "constraints": {
                "node_name": "Genes with paralogs",
                "gene_properties": {
                    "property_flags": [
                        "has_paralog"
                    ]
                }
            }
        },
        "canned_query:genes_with_annotated_protein_feature": {
            "name": "Genes annotated with protein features ",
            "constraints": {
                "term": {
                    "termid": "SO:0000839",
                    "name": " polypeptide_region"
                }
            }
        },
        "canned_query:genes_with_tm_domain_from_deeptmhmm": {
            "name": "Genes with TM domain predicted by DeepTMHMM",
            "constraints": {
                "or": [
                    {
                        "node_name": "DeepTMHMM Periplasmic Domains",
                        "subset": {
                            "subset_name": "interpro:DeepTMHMM:Periplasmic Domain"

                        }
                    },
                    {
                        "node_name": "DeepTMHMM Transmembrane alpha helix",
                        "subset": {
                            "subset_name": "interpro:DeepTMHMM:Transmembrane alpha helix"

                        }
                    },
                    {
                        "node_name": "DeepTMHMM Periplasmic Domains",
                        "subset": {
                            "subset_name": "interpro:DeepTMHMM:Transmembrane beta barrel"
                        }
                    }
                ]
            }
        },
        "canned_query:genes_with_signal_peptide": {
            "name": "Genes with predicted signal peptide",
            "constraints": {
                "term": {
                    "termid": "SO:0000418",
                    "name": "signal_peptide"
                }
            }
        },
        "canned_query:genes_in_complexes": {
            "name": "RNAs and proteins in macromolecular complexes",
            "constraints": {
                "term": {
                    "termid": "GO:0032991",
                    "name": "protein-containing complex"
                }
            }
        },
        "canned_query:proteins_in_complexes": {
            "name": "Proteins in macromolecular complexes",
            "constraints": {
                "and": [
                    {
                        "not": [
                            {
                                "not": [
                                    {
                                        "node_name": "subset: feature_type_mRNA_gene",
                                        "subset": {
                                            "subset_name": "feature_type_mRNA_gene"
                                        }
                                    },
                                    {
                                        "node_name": "subset: characterisation_status_transposon",
                                        "subset": {
                                            "subset_name": "characterisation_status_transposon"
                                        }
                                    }
                                ],
                                "node_name": "subset: feature_type_mRNA_gene NOT subset: characterisation_status_transposon"
                            },
                            {
                                "node_name": "subset: characterisation_status_dubious",
                                "subset": {
                                    "subset_name": "characterisation_status_dubious"
                                }
                            }
                        ],
                        "node_name": "All protein coding genes (excluding dubious and transposon)"
                    },
                    {
                        "node_name": "genes annotated with \"protein-containing complex\" (GO:0032991)",
                        "term": {
                            "termid": "GO:0032991",
                            "name": "protein-containing complex"
                        }
                    }
                ]
            }
        },
        "canned_query:coding_genes_with_mf_annotation": {
            "name": "Protein coding genes with GO molecular function annotation",
            "constraints": {
                "and": [
                    {
                        "not": [
                            {
                                "not": [
                                    {
                                        "node_name": "subset: feature_type_mRNA_gene",
                                        "subset": {
                                            "subset_name": "feature_type_mRNA_gene"
                                        }
                                    },
                                    {
                                        "node_name": "subset: characterisation_status_transposon",
                                        "subset": {
                                            "subset_name": "characterisation_status_transposon"
                                        }
                                    }
                                ],
                                "node_name": "subset: feature_type_mRNA_gene NOT subset: characterisation_status_transposon"
                            },
                            {
                                "node_name": "subset: characterisation_status_dubious",
                                "subset": {
                                    "subset_name": "characterisation_status_dubious"
                                }
                            }
                        ],
                        "node_name": "All protein coding genes (excluding dubious and transposon)"
                    },
                    {
                        "node_name": "genes annotated with \"molecular_function\" (GO:0003674)",
                        "term": {
                            "termid": "GO:0003674",
                            "name": "molecular_function",
                            "ploidiness": null,
                            "expression": null
                        }
                    }
                ],
                "node_name": "genes annotated with \"molecular_function\" (GO:0003674) AND (All protein coding genes (excluding dubious and transposon))"
            },
            "output_options": {}
        },
        "canned_query:coding_genes_with_bp_annotation": {
            "name": "Protein coding genes with GO biological process annotation",
            "constraints": {
                "and": [
                    {
                        "not": [
                            {
                                "not": [
                                    {
                                        "node_name": "subset: feature_type_mRNA_gene",
                                        "subset": {
                                            "subset_name": "feature_type_mRNA_gene"
                                        }
                                    },
                                    {
                                        "node_name": "subset: characterisation_status_transposon",
                                        "subset": {
                                            "subset_name": "characterisation_status_transposon"
                                        }
                                    }
                                ],
                                "node_name": "subset: feature_type_mRNA_gene NOT subset: characterisation_status_transposon"
                            },
                            {
                                "node_name": "subset: characterisation_status_dubious",
                                "subset": {
                                    "subset_name": "characterisation_status_dubious"
                                }
                            }
                        ],
                        "node_name": "All protein coding genes (excluding dubious and transposon)"
                    },
                    {
                        "node_name": "genes annotated with \"biological_process\" (GO:0008150)",
                        "term": {
                            "termid": "GO:0008150",
                            "name": "biological_process",
                            "ploidiness": null,
                            "expression": null
                        }
                    }
                ],
                "node_name": "genes annotated with \"biological_process\" (GO:0008150) AND (All protein coding genes (excluding dubious and transposon))"
            },
            "output_options": {}
        },
        "canned_query:coding_genes_with_mf_and_bp_annotation": {
            "name": "Protein coding genes with GO biological process and molecular function annotation",
            "constraints": {
                "and": [
                    {
                        "not": [
                            {
                                "not": [
                                    {
                                        "node_name": "subset: feature_type_mRNA_gene",
                                        "subset": {
                                            "subset_name": "feature_type_mRNA_gene"
                                        }
                                    },
                                    {
                                        "node_name": "subset: characterisation_status_transposon",
                                        "subset": {
                                            "subset_name": "characterisation_status_transposon"
                                        }
                                    }
                                ],
                                "node_name": "subset: feature_type_mRNA_gene NOT subset: characterisation_status_transposon"
                            },
                            {
                                "node_name": "subset: characterisation_status_dubious",
                                "subset": {
                                    "subset_name": "characterisation_status_dubious"
                                }
                            }
                        ],
                        "node_name": "(subset: feature_type_mRNA_gene NOT subset: characterisation_status_transposon) NOT subset: characterisation_status_dubious"
                    },
                    {
                        "node_name": "genes annotated with \"biological_process\" (GO:0008150)",
                        "term": {
                            "termid": "GO:0008150",
                            "name": "biological_process",
                            "ploidiness": null,
                            "expression": null
                        }
                    },
                    {
                        "node_name": "genes annotated with \"molecular_function\" (GO:0003674)",
                        "term": {
                            "termid": "GO:0003674",
                            "name": "molecular_function",
                            "ploidiness": null,
                            "expression": null
                        }
                    }
                ],
                "node_name": "((subset: feature_type_mRNA_gene NOT subset: characterisation_status_transposon) NOT subset: characterisation_status_dubious) AND genes annotated with \"biological_process\" (GO:0008150) AND genes annotated with \"molecular_function\" (GO:0003674)"
            },
            "output_options": {}
        },
        "canned_query:genes_with_rna_levels_increased_during_cesr": {
            "name": "Genes with RNA level increased during Core Environmental Stress Response",
            "constraints": {
                "node_name": "genes annotated with \"RNA level increased during Core Environmental Stress Response\" (PomGeneEx:0000028)",
                "term": {
                    "termid": "PomGeneEx:0000028",
                    "name": "RNA level increased during Core Environmental Stress Response",
                    "ploidiness": null,
                    "expression": null
                }
            },
            "output_options": {}
        },
        "canned_query:genes_with_rna_levels_decreased_during_cesr": {
            "name": "Genes with RNA level decreased during Core Environmental Stress Response",
            "constraints": {
                "node_name": "genes annotated with \"RNA level decreased during Core Environmental Stress Response\" (PomGeneEx:0000028)",
                "term": {
                    "termid": "PomGeneEx:0000029",
                    "name": "RNA level decreased during Core Environmental Stress Response",
                    "ploidiness": null,
                    "expression": null
                }
            },
            "output_options": {}
        }
    },
    "api_seq_chunk_sizes": [
        10000,
        200000
    ],
    "chromosomes": [
        {
            "name": "chromosome_1",
            "export_id": "I",
            "export_file_id": "chromosome_I",
            "short_display_name": "I",
            "long_display_name": "Chromosome I"
        },
        {
            "name": "chromosome_2",
            "export_id": "II",
            "export_file_id": "chromosome_II",
            "short_display_name": "II",
            "long_display_name": "Chromosome II"
        },
        {
            "name": "chromosome_3",
            "export_id": "III",
            "export_file_id": "chromosome_III",
            "short_display_name": "III",
            "long_display_name": "Chromosome III"
        },
        {
            "name": "mitochondrial",
            "export_id": "mitochondrial",
            "export_file_id": "mitochondrial_chromosome",
            "short_display_name": "Mitochondrial",
            "long_display_name": "Mitochondrial chromosome"
        },
        {
            "name": "mating_type_region",
            "export_id": "mating_type_region",
            "export_file_id": "mating_type_region",
            "short_display_name": "Mating type region",
            "long_display_name": "Mating type region"
        },
        {
            "name": "chr_II_telomeric_gap",
            "export_id": "chr_II_telomeric_gap",
            "export_file_id": "chr_II_telomeric_gap",
            "short_display_name": "Chromosome II telomeric gap",
            "long_display_name": "Chromosome II telomeric gap"
        }
    ],
    "extension_display_names": [
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0140567",
            "display_name": "extracts",
            "reciprocal_display": "extracted by"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0140299",
            "display_name": "senses",
            "reciprocal_display": "sensed by"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0140597",
            "display_name": "chaperones",
            "reciprocal_display": "chaperoned by"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0004721",
            "display_name": "dephosphorylates",
            "reciprocal_display": "dephosphorylated by"
        },
        {
            "rel_name": "activated_by",
            "display_name": "activated by"
        },
        {
            "rel_name": "coincident_with",
            "display_name": "at"
        },
        {
            "rel_name": "directly_negatively_regulates",
            "display_name": "directly inhibits",
            "reciprocal_display": "directly inhibited by"
        },
        {
            "rel_name": "directly_positively_regulates",
            "display_name": "directly activates",
            "reciprocal_display": "directly activated by"
        },
        {
            "rel_name": "during",
            "display_name": "during"
        },
        {
            "rel_name": "exists_during",
            "display_name": "during"
        },
        {
            "rel_name": "happens_during",
            "display_name": "during"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0000976",
            "display_name": "binds promoter of",
            "reciprocal_display": "promoter bound by"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0003713",
            "display_name": "activates transcription of",
            "reciprocal_display": "transcription activated by"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0003714",
            "display_name": "represses transcription of",
            "reciprocal_display": "transcription repressed by"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0001671",
            "display_name": "activates",
            "reciprocal_display": "activated by"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0000772",
            "display_name": "activates",
            "reciprocal_display": "activated by"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0004857",
            "display_name": "inhibits",
            "reciprocal_display": "inhibited by"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0008150",
            "display_name": "regulates",
            "reciprocal_display": "regulated by"
        },
        {
            "rel_name": "in_presence_of",
            "display_name": "in presence of"
        },
        {
            "rel_name": "inhibited_by",
            "display_name": "inhibited by"
        },
        {
            "rel_name": "not_during",
            "display_name": "except during"
        },
        {
            "rel_name": "not_exists_during",
            "display_name": "except during"
        },
        {
            "rel_name": "not_happens_during",
            "display_name": "except during"
        },
        {
            "rel_name": "occurs_at",
            "display_name": "at"
        },
        {
            "rel_name": "occurs_in",
            "display_name": "in"
        },
        {
            "rel_name": "part_of",
            "if_descendant_of": "GO:0003824",
            "display_name": "involved in"
        },
        {
            "rel_name": "part_of",
            "if_descendant_of": "GO:0098772",
            "display_name": "involved in"
        },
        {
            "rel_name": "part_of",
            "if_descendant_of": "GO:0140104",
            "display_name": "involved in"
        },
        {
            "rel_name": "part_of",
            "if_descendant_of": "GO:0140223",
            "display_name": "involved in"
        },
        {
            "rel_name": "part_of",
            "if_descendant_of": "GO:0008150",
            "display_name": "part of"
        },
        {
            "rel_name": "required_for",
            "display_name": "required for"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0001216",
            "display_name": "activates transcription of",
            "reciprocal_display": "transcription activated by"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0001217",
            "display_name": "represses transcription of",
            "reciprocal_display": "transcription repressed by"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0004842",
            "display_name": "ubiquitinates",
            "reciprocal_display": "ubiquitinated by"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0004672",
            "display_name": "phosphorylates",
            "reciprocal_display": "phosphorylated by"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0003824",
            "display_name": "has substrate",
            "reciprocal_display": "substrate of"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0006810",
            "display_name": "transports",
            "reciprocal_display": "transported by"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0005215",
            "display_name": "transports",
            "reciprocal_display": "transported by"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0005488",
            "display_name": "binds",
            "reciprocal_display": "binds"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0005484",
            "display_name": "recruits",
            "reciprocal_display": "recruited by"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0008093",
            "display_name": "anchors",
            "reciprocal_display": "anchored by"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0140566",
            "display_name": "reads",
            "reciprocal_display": "read by"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0030674",
            "display_name": "recruits",
            "reciprocal_display": "recruited by"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0051179",
            "display_name": "localizes",
            "reciprocal_display": "localized by"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0140313",
            "display_name": "sequesters",
            "reciprocal_display": "sequestered by"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0140677",
            "display_name": "activates",
            "reciprocal_display": "activated by"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0140678",
            "display_name": "inhibits",
            "reciprocal_display": "inhibited by"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0098772",
            "display_name": "regulates",
            "reciprocal_display": "regulated by"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0044183",
            "display_name": "chaperones",
            "reciprocal_display": "chaperoned by"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0140142",
            "display_name": "carries",
            "carries_display": "carried by"
        },
        {
            "rel_name": "assayed_using",
            "if_descendant_of": "FYPO:0001370",
            "display_name": "affecting",
            "reciprocal_display": "localization affected by mutation in"
        },
        {
            "rel_name": "assayed_protein",
            "if_descendant_of": "FYPO:0001370",
            "display_name": "affecting",
            "reciprocal_display": "localization affected by mutation in"
        },
        {
            "rel_name": "assayed_using",
            "if_descendant_of": "FYPO:0001985",
            "display_name": "affecting",
            "reciprocal_display": "affected by mutation in"
        },
        {
            "rel_name": "assayed_enzyme",
            "if_descendant_of": "FYPO:0001985",
            "display_name": "affecting activity of",
            "reciprocal_display": "activity affected by mutation in"
        },
        {
            "rel_name": "assayed_substrate",
            "if_descendant_of": "FYPO:0001985",
            "display_name": "affecting substrate",
            "reciprocal_display": "affected by mutation in"
        },
        {
            "rel_name": "assayed_using",
            "if_descendant_of": "FYPO:0000257",
            "display_name": "affecting"
        },
        {
            "rel_name": "assayed_enzyme",
            "if_descendant_of": "FYPO:0000257",
            "display_name": "affecting activity of"
        },
        {
            "rel_name": "assayed_substrate",
            "if_descendant_of": "FYPO:0000257",
            "display_name": "affecting"
        },
        {
            "rel_name": "assayed_protein",
            "if_descendant_of": "FYPO:0001985",
            "display_name": "affecting",
            "reciprocal_display": "affected by mutation in"
        },
        {
            "rel_name": "assayed_protein",
            "if_descendant_of": "FYPO:0000257",
            "display_name": "affecting"
        },
        {
            "rel_name": "assayed_transcript",
            "if_descendant_of": "FYPO:0001985",
            "display_name": "affecting",
            "reciprocal_display": "affected by mutation in"
        },
        {
            "rel_name": "assayed_transcript",
            "if_descendant_of": "FYPO:0000257",
            "display_name": "affecting"
        },
        {
            "rel_name": "assayed_region",
            "if_descendant_of": "FYPO:0001985",
            "display_name": "affected region",
            "reciprocal_display": "affected by mutation in"
        },
        {
            "rel_name": "assayed_region",
            "if_descendant_of": "FYPO:0000257",
            "display_name": "affected region"
        },
        {
            "rel_name": "residue",
            "if_descendant_of": "FYPO:0000001",
            "display_name": "modified residue"
        },
        {
            "rel_name": "residue",
            "if_descendant_of": "GO:0005515",
            "display_name": "binding site"
        },
        {
            "rel_name": "residue",
            "if_descendant_of": "MOD:00689",
            "display_name": "residue"
        },
        {
            "rel_name": "residue",
            "if_descendant_of": "MOD:00000",
            "display_name": "modified residue"
        },
        {
            "rel_name": "active_form",
            "if_descendant_of": "GO:0003674",
            "display_name": "active form"
        },
        {
            "rel_name": "active_form",
            "if_descendant_of": "GO:0008150",
            "display_name": "active form"
        },
        {
            "rel_name": "active_form",
            "if_descendant_of": "GO:0005575",
            "display_name": "localized form"
        },
        {
            "rel_name": "has_input",
            "if_descendant_of": "GO:0000981",
            "display_name": "regulates transcription of",
            "reciprocal_display": "transcription regulated by"
        }
    ],
    "extension_relation_order": {
        "relation_order": [
            "active_form",
            "assayed_using",
            "assayed_enzyme",
            "assayed_substrate",
            "assayed_protein",
            "assayed_transcript",
            "assayed_region",
            "residue",
            "modified residue",
            "directly_positively_regulates",
            "directly_negatively_regulates",
            "has_input",
            "binds",
            "activated by",
            "carried by",
            "involved_in",
            "part_of",
            "occurs_at",
            "occurs_in",
            "added_by",
            "added_during",
            "increased_during",
            "present_during",
            "in_presence_of",
            "removed_by",
            "removed_during",
            "decreased_during",
            "increased_in_presence_of",
            "decreased_in_presence_of",
            "absent_during",
            "has_severity",
            "has_penetrance"
        ],
        "always_last": [
            "happens_during",
            "exists_during"
        ]
    },
    "term_page_extensions_cv_names": [],
    "evidence_types": {
        "IMP": {
            "long": "Inferred from Mutant Phenotype",
            "link": "http://wiki.geneontology.org/index.php/Inferred_from_Mutant_Phenotype_(IMP)"
        },
        "IDA": {
            "long": "Inferred from Direct Assay",
            "link": "http://wiki.geneontology.org/index.php/Inferred_from_Direct_Assay_(IDA)"
        },
        "IGI": {
            "long": "Inferred from Genetic Interaction",
            "link": "http://wiki.geneontology.org/index.php/Inferred_from_Genetic_Interaction_(IGI)"
        },
        "IPI": {
            "long": "Inferred from Physical Interaction",
            "link": "http://wiki.geneontology.org/index.php/Inferred_from_Physical_Interaction_(IPI)"
        },
        "EXP": {
            "long": "Inferred from Experiment",
            "link": "http://wiki.geneontology.org/index.php/Inferred_from_Experiment_(EXP)"
        },
        "IEP": {
            "long": "Inferred from Expression Pattern",
            "link": "http://wiki.geneontology.org/index.php/Inferred_from_Expression_Pattern_(IEP)"
        },
        "ISS": {
            "long": "Inferred from Sequence or Structural Similarity",
            "link": "http://wiki.geneontology.org/index.php/Inferred_from_Sequence_or_structural_Similarity_(ISS)"
        },
        "ISO": {
            "long": "Inferred from Sequence Orthology",
            "link": "http://wiki.geneontology.org/index.php/Inferred_from_Sequence_Orthology_(ISO)"
        },
        "ISA": {
            "long": "Inferred from Sequence Alignment",
            "link": "http://wiki.geneontology.org/index.php/Inferred_from_Sequence_Alignment_(ISA)"
        },
        "ISM": {
            "long": "Inferred from Sequence Model",
            "link": "http://wiki.geneontology.org/index.php/Inferred_from_Sequence_Model_(ISM)"
        },
        "IGC": {
            "long": "Inferred from Genomic Context",
            "link": "http://wiki.geneontology.org/index.php/Inferred_from_Genomic_Context_(IGC)"
        },
        "IBA": {
            "long": "Inferred from Biological aspect of Ancestor",
            "link": "http://wiki.geneontology.org/index.php/Inferred_from_Biological_aspect_of_Ancestor_(IBA)"
        },
        "IBD": {
            "long": "Inferred from Biological aspect of Descendant",
            "link": "http://wiki.geneontology.org/index.php/Inferred_from_Biological_aspect_of_Descendant_(IBD)"
        },
        "IKR": {
            "long": "Inferred from Key Residues",
            "link": "http://wiki.geneontology.org/index.php/Inferred_from_Key_Residues_(IKR)"
        },
        "IRD": {
            "long": "Inferred from Rapid Divergence",
            "link": "http://wiki.geneontology.org/index.php/Inferred_from_Rapid_Divergence(IRD)"
        },
        "RCA": {
            "long": "inferred from Reviewed Computational Analysis",
            "link": "http://wiki.geneontology.org/index.php/Inferred_from_Reviewed_Computational_Analysis_(RCA)"
        },
        "NAS": {
            "long": "Non-traceable Author Statement",
            "link": "http://wiki.geneontology.org/index.php/Non-traceable_Author_Statement_(NAS)"
        },
        "IC": {
            "long": "Inferred by Curator",
            "link": "http://wiki.geneontology.org/index.php/Inferred_by_Curator_(IC)"
        },
        "ND": {
            "long": "No biological Data available",
            "link": "http://wiki.geneontology.org/index.php/No_biological_Data_available_(ND)_evidence_code"
        },
        "IEA": {
            "long": "Inferred from Electronic Annotation",
            "link": "http://wiki.geneontology.org/index.php/Inferred_from_Electronic_Annotation_(IEA)"
        },
        "NR": {
            "long": "Not Recorded",
            "link": "http://wiki.geneontology.org/index.php/Guide_to_GO_Evidence_Codes"
        },
        "TAS": {
            "long": "Traceable Author Statement",
            "link": "http://wiki.geneontology.org/index.php/Traceable_Author_Statement_(TAS)"
        },
        "HTP": {
            "long": "Inferred from high throughput experiment",
            "link": "http://wiki.geneontology.org/index.php/Inferred_from_High_Throughput_Experiment_(HTP)"
        },
        "HDA": {
            "long": "Inferred from high throughput direct assay",
            "link": "http://wiki.geneontology.org/index.php/Inferred_from_High_Throughput_Direct_Assay_(HDA)"
        },
        "HEP": {
            "long": "Inferred from high throughput expression pattern",
            "link": "http://wiki.geneontology.org/index.php/Inferred_from_High_Throughput_Expression_Pattern_(HEP)"
        },
        "HGI": {
            "long": "Inferred from high throughput genetic interaction",
            "link": "http://wiki.geneontology.org/index.php/Inferred_from_High_Throughput_Genetic_Interaction_(HGI)"
        },
        "HMP": {
            "long": "Inferred from high throughput mutant phenotype",
            "link": "http://wiki.geneontology.org/index.php/Inferred_from_High_Throughput_Mutant_Phenotype_(HMP)"
        },
        "UNK": {
            "long": "Unknown"
        }
    },
    "extension_categories": {
        "during": [
            {
                "display_name": "mitotic interphase",
                "ancestors": [
                    "GO:0051329"
                ]
            },
            {
                "display_name": "mitotic G1 phase",
                "ancestors": [
                    "GO:0000080"
                ]
            },
            {
                "display_name": "mitotic S phase",
                "ancestors": [
                    "GO:0000084"
                ]
            },
            {
                "display_name": "mitotic G2 phase",
                "ancestors": [
                    "GO:0000085"
                ]
            },
            {
                "display_name": "mitotic M phase",
                "ancestors": [
                    "GO:0000087"
                ]
            },
            {
                "display_name": "mitotic prophase",
                "ancestors": [
                    "GO:0000088"
                ]
            },
            {
                "display_name": "mitotic metaphase",
                "ancestors": [
                    "GO:0000089"
                ]
            },
            {
                "display_name": "mitotic anaphase",
                "ancestors": [
                    "GO:0000090"
                ]
            },
            {
                "display_name": "mitotic telophase",
                "ancestors": [
                    "GO:0000093"
                ]
            },
            {
                "display_name": "meiotic S phase",
                "ancestors": [
                    "GO:0051332"
                ]
            },
            {
                "display_name": "meiotic M phase",
                "ancestors": [
                    "GO:0051327"
                ]
            },
            {
                "display_name": "meiotic interphase",
                "ancestors": [
                    "GO:0051328"
                ]
            },
            {
                "display_name": "meiotic prophase I",
                "ancestors": [
                    "GO:0007128"
                ]
            },
            {
                "display_name": "meiotic metaphase I",
                "ancestors": [
                    "GO:0007132"
                ]
            },
            {
                "display_name": "meiotic anaphase I",
                "ancestors": [
                    "GO:0007133"
                ]
            },
            {
                "display_name": "meiotic telophase I",
                "ancestors": [
                    "GO:0007134"
                ]
            },
            {
                "display_name": "meiotic metaphase II",
                "ancestors": [
                    "GO:0007137"
                ]
            },
            {
                "display_name": "meiotic anaphase II",
                "ancestors": [
                    "GO:0007138"
                ]
            },
            {
                "display_name": "meiotic telophase II",
                "ancestors": [
                    "GO:0007139"
                ]
            }
        ]
    },
    "cv_config": {
        "fission_yeast_phenotype": {
            "feature_type": "genotype",
            "display_name": "Phenotype",
            "columns_to_show": [
                "term_id",
                "desc-rel",
                "genotype",
                "genotype_background",
                "allele_promoters",
                "evidence",
                "conditions",
                "reference",
                "extension"
            ],
            "columns_to_show_by_page_type": {
                "reference": ["annotation_phenotype_score"]
            },
            "external_db_link_keys": [
                "BioPortal"
            ],
            "filters": [
                {
                    "filter_type": "ploidiness",
                    "display_name": "Haploid/Diploid",
                    "scope": [
                        "gene",
                        "term",
                        "reference"
                    ],
                    "detailed_view_only": false
                },
                {
                    "filter_type": "term",
                    "display_name": "Term",
                    "scope": [
                        "gene",
                        "genotype",
                        "reference"
                    ],
                    "detailed_view_only": false,
                    "term_categories": [
                        {
                            "ancestors": [
                                "FYPO:0000257"
                            ],
                            "display_name": "Normal phenotype"
                        },
                        {
                            "ancestors": [
                                "FYPO:0001985"
                            ],
                            "display_name": "Abnormal phenotype"
                        },
                        {
                            "ancestors": [
                                "FYPO:0001320"
                            ],
                            "display_name": "Vegetative cell phenotype"
                        },
                        {
                            "ancestors": [
                                "FYPO:0002683"
                            ],
                            "display_name": "Sensitive to chemical"
                        },
                        {
                            "ancestors": [
                                "FYPO:0005447"
                            ],
                            "display_name": "Abnormal biological process"
                        },
                        {
                            "ancestors": [
                                "FYPO:0000005"
                            ],
                            "display_name": "Abnormal cell morphology"
                        },
                        {
                            "ancestors": [
                                "FYPO:0000631"
                            ],
                            "display_name": "Cell cycle phenotype"
                        },
                        {
                            "ancestors": [
                                "FYPO:0000138"
                            ],
                            "display_name": "Localization phenotype"
                        },
                        {
                            "ancestors": [
                                "FYPO:0000004"
                            ],
                            "display_name": "Cell viability"
                        },
                        {
                            "ancestors": [
                                "FYPO:0002057"
                            ],
                            "display_name": "Cell population viability"
                        },
                        {
                            "ancestors": [
                                "FYPO:0000707"
                            ],
                            "display_name": "Abnormal molecular function"
                        },
                        {
                            "ancestors": [
                                "FYPO:0000702"
                            ],
                            "display_name": "Protein-protein interaction"
                        },
                        {
                            "ancestors": [
                                "FYPO:0000661"
                            ],
                            "display_name": "Abnormal catalytic activity"
                        }
                    ]
                },
                {
                    "filter_type": "evidence",
                    "display_name": "Evidence",
                    "scope": [
                        "gene",
                        "term",
                        "genotype",
                        "reference"
                    ],
                    "detailed_view_only": true,
                    "evidence_categories": [
                        {
                            "display_name": "Microscopy",
                            "evidence_codes": [
                                "Microscopy",
                                "immunofluorescence",
                                "Epitope-tagged protein immunolocalization experiment data",
                                "Immunolocalization experiment data",
                                "Fusion protein localization",
                                "In situ hybridization assay"
                            ]
                        },
                        {
                            "display_name": "Gel electrophoresis",
                            "evidence_codes": [
                                "Gel electrophoresis",
                                "Sodium dodecyl sulfate polyacrylamide gel electrophoresis",
                                "RNA protection assay"
                            ]
                        },
                        {
                            "display_name": "Western blot",
                            "evidence_codes": [
                                "Western blot",
                                "Western blot assay"
                            ]
                        },
                        {
                            "display_name": "Co-immunoprecipitation experiment",
                            "evidence_codes": [
                                "Co-immunoprecipitation experiment"
                            ]
                        },
                        {
                            "display_name": "Cell growth assay",
                            "evidence_codes": [
                                "Cell growth assay"
                            ]
                        },
                        {
                            "display_name": "Chromatin immunoprecipitation experiment",
                            "evidence_codes": [
                                "Chromatin immunoprecipitation experiment"
                            ]
                        },
                        {
                            "display_name": "Chromatography",
                            "evidence_codes": [
                                "Chromatography"
                            ]
                        },
                        {
                            "display_name": "Competitive growth assay",
                            "evidence_codes": [
                                "Competitive growth assay"
                            ]
                        },
                        {
                            "display_name": "Electrophoretic mobility shift assay data",
                            "evidence_codes": [
                                "Electrophoretic mobility shift assay data"
                            ]
                        },
                        {
                            "display_name": "Enzyme assay data",
                            "evidence_codes": [
                                "Enzyme assay data"
                            ]
                        },
                        {
                            "display_name": "Experimental phenotypic",
                            "evidence_codes": [
                                "Experimental phenotypic"
                            ]
                        },
                        {
                            "display_name": "Flow cytometry data",
                            "evidence_codes": [
                                "Flow cytometry data"
                            ]
                        },
                        {
                            "display_name": "High throughput nucleotide sequencing assay",
                            "evidence_codes": [
                                "High throughput nucleotide sequencing assay"
                            ]
                        },
                        {
                            "display_name": "Inferred from Mutant Phenotype",
                            "evidence_codes": [
                                "Inferred from Mutant Phenotype"
                            ]
                        },
                        {
                            "display_name": "Northern assay",
                            "evidence_codes": [
                                "Northern assay"
                            ]
                        },
                        {
                            "display_name": "Particle size and count assay",
                            "evidence_codes": [
                                "Particle size and count assay"
                            ]
                        },
                        {
                            "display_name": "Plasmid maintenance assay",
                            "evidence_codes": [
                                "Plasmid maintenance assay"
                            ]
                        },
                        {
                            "display_name": "Quantitative PCR",
                            "evidence_codes": [
                                "Quantitative PCR"
                            ]
                        },
                        {
                            "display_name": "Reporter gene assay",
                            "evidence_codes": [
                                "Reporter gene assay"
                            ]
                        },
                        {
                            "display_name": "Substance quantification",
                            "evidence_codes": [
                                "Substance quantification"
                            ]
                        },
                        {
                            "display_name": "Transcript expression level",
                            "evidence_codes": [
                                "Transcript expression level"
                            ]
                        },
                        {
                            "display_name": "Other",
                            "evidence_codes": [
                                "Other",
                                "Other direct assay"
                            ]
                        }
                    ]
                },
                {
                    "filter_type": "throughput",
                    "display_name": "Throughput",
                    "scope": [
                        "gene",
                        "term",
                        "genotype",
                        "reference"
                    ],
                    "detailed_view_only": true,
                    "throughput_categories": [
                        {
                            "display_name": "High",
                            "throughput_type": "high"
                        },
                        {
                            "display_name": "Low",
                            "throughput_type": "low"
                        },
                        {
                            "display_name": "Non-experimental",
                            "throughput_type": "non-experimental"
                        }
                    ]
                }
            ],
            "split_by_parents": [
                {
                    "config_name": "cell_phenotype",
                    "termids": [
                        "FYPO:0000002",
                        "FYPO:0000652",
                        "FYPO:0000301",
                        "FYPO:0000680",
                        "FYPO:0001312",
                        "FYPO:0002928",
                        "FYPO:0002931",
                        "FYPO:0002929",
                        "FYPO:0003048",
                        "FYPO:0003093",
                        "FYPO:0003290",
                        "FYPO:0003324",
                        "FYPO:0003427",
                        "FYPO:0003480",
                        "FYPO:0004914",
                        "FYPO:0004915",
                        "FYPO:0004942",
                        "FYPO:0005156",
                        "FYPO:0005157",
                        "FYPO:0006297",
                        "FYPO:0006790",
                        "FYPO:0006793",
                        "FYPO:0007135",
                        "FYPO:0007170",
                        "FYPO:0007394",
                        "FYPO:0007477",
                        "FYPO:0007479",
                        "FYPO:0007491"
                    ],
                    "display_name": "cell"
                },
                {
                    "config_name": "population_phenotype",
                    "termids": [
                        "FYPO:0000003",
                        "FYPO:0001155"
                    ],
                    "display_name": "population"
                }
            ],
            "summary_relations_to_hide": [
                "has_penetrance",
                "has_severity"
            ],
            "summary_relation_ranges_to_collect": [
                "affecting",
                "assayed_enzyme",
                "assayed_substrate",
                "assayed_using",
                "residue"
            ]
        },
        "single_locus_phenotype": {
            "feature_type": "genotype",
            "display_name": "Single locus phenotype",
            "menu_item_label": "single locus",
            "inherits_from": "fission_yeast_phenotype",
            "downstream_query_title": "Send all downstream (affected) genes to the Advanced Search ...",
            "downstream_relations": [
                "assayed_using", "assayed_substrate", "assayed_protein", "assayed_transcript", "assayed_enzyme"
            ],
            "single_or_multi_locus": "single",
            "help_route": "/documentation/gene-page-phenotypes"
        },
        "multi_locus_phenotype": {
            "feature_type": "genotype",
            "display_name": "Multi-locus phenotype",
            "menu_item_label": "multi-locus",
            "inherits_from": "fission_yeast_phenotype",
            "single_or_multi_locus": "multi",
            "help_route": "/documentation/gene-page-phenotypes"
        },
        "fission_yeast_phenotype_condition": {
            "feature_type": "genotype",
            "display_name": "Phenotype condition",
            "columns_to_show": [
                "term_id",
                "desc-rel",
                "genotype",
                "evidence",
                "qualifiers",
                "reference",
                "count",
                "extension"
            ]
        },
        "molecular_function": {
            "feature_type": "gene",
            "display_name": "GO molecular function",
            "menu_item_label": "Molecular function",
            "columns_to_show": [
                "term_id",
                "desc-rel",
                "gene",
                "evidence",
                "qualifiers",
                "reference",
                "count",
                "extension"
            ],
            "external_db_link_keys": [
                "AmiGO",
                "QuickGO",
                "BioPortal"
            ],
            "slim_subset_name": "mf_goslim_pombe",
            "slim_description": "Molecular function overview (GO slim)",
            "slim_link": "/browse-curation/fission-yeast-mf-go-slim-terms",
            "slim_no_category_text": "molecular function GO Slim category",
            "split_by_parents": [
                {
                    "config_name": "not-binding",
                    "termids": [
                        "NOT GO:0005488"
                    ],
                    "display_name": "activities"
                },
                {
                    "config_name": "binding",
                    "termids": [
                        "GO:0005488"
                    ],
                    "display_name": "binding"
                }
            ],
            "summary_relations_to_hide": [],
            "ontology_graph_url": "https://www.ebi.ac.uk/QuickGO/services/ontology/go/terms/{ids}/chart?base64=false&showKey=true&showIds=true&termBoxWidth=120&termBoxHeight=65&showSlimColours=false&showChildren=true&fontSize=11&ids=",
            "summary_relation_ranges_to_collect": [
                "directly_activates",
                "directly_inhibits",
                "has_input",
                "has_substrate",
                "binds"
            ],
            "downstream_query_title": "Send all substrate genes to Advanced Search ...",
            "downstream_relations": [
                "RO:0002233"
            ],
            "filters": [
                {
                    "filter_type": "extension",
                    "filter_subtype": "during",
                    "display_name": "During",
                    "scope": [
                        "gene",
                        "term",
                        "genotype",
                        "reference"
                    ],
                    "detailed_view_only": true,
                    "extension_rel_type_names": [
                        "during",
                        "happens_during",
                        "exists_during"
                    ]
                },
                {
                    "filter_type": "term",
                    "display_name": "Slim term",
                    "scope": [
                        "gene",
                        "reference"
                    ],
                    "detailed_view_only": false,
                    "slim_name": "mf_goslim_pombe"
                },
                {
                    "filter_type": "throughput",
                    "display_name": "Evidence type",
                    "scope": [
                        "gene",
                        "term",
                        "genotype",
                        "reference"
                    ],
                    "detailed_view_only": true,
                    "throughput_categories": [
                        {
                            "display_name": "High throughput experiment",
                            "throughput_type": "high"
                        },
                        {
                            "display_name": "Low throughput experiment",
                            "throughput_type": "low"
                        },
                        {
                            "display_name": "All experimental annotation",
                            "throughput_type": "high|low"
                        },
                        {
                            "display_name": "Inferred",
                            "throughput_type": "non-experimental"
                        }
                    ]
                }
            ],
            "help_route": "/documentation/gene-page-gene-ontology"
        },
        "biological_process": {
            "feature_type": "gene",
            "display_name": "GO biological process",
            "menu_item_label": "Biological process",
            "columns_to_show": [
                "term_id",
                "desc-rel",
                "gene",
                "evidence",
                "qualifiers",
                "reference",
                "count",
                "extension"
            ],
            "external_db_link_keys": [
                "AmiGO",
                "QuickGO",
                "BioPortal"
            ],
            "external_link_config": [
                {
                    "display_text": "View process term ancestry ...",
                    "url_prefix": "https://www.ebi.ac.uk/QuickGO/services/ontology/go/terms/{ids}/chart?ids="
                }
            ],
            "ontology_graph_url": "https://www.ebi.ac.uk/QuickGO/services/ontology/go/terms/{ids}/chart?base64=false&showKey=true&showIds=true&termBoxWidth=120&termBoxHeight=65&showSlimColours=false&showChildren=true&fontSize=11&ids=",
            "summary_relation_ranges_to_collect": [
                "has_input"
            ],
            "slim_subset_name": "bp_goslim_pombe",
            "slim_description": "Biological process overview (GO slim)",
            "slim_link": "/browse-curation/fission-yeast-bp-go-slim-terms",
            "slim_no_category_text": "biological process GO Slim category",
            "filters": [
                {
                    "filter_type": "extension",
                    "filter_subtype": "during",
                    "display_name": "During",
                    "scope": [
                        "gene",
                        "term",
                        "genotype",
                        "reference"
                    ],
                    "detailed_view_only": true,
                    "extension_rel_type_names": [
                        "during",
                        "happens_during",
                        "exists_during"
                    ]
                },
                {
                    "filter_type": "term",
                    "display_name": "Slim term",
                    "scope": [
                        "gene",
                        "reference"
                    ],
                    "detailed_view_only": false,
                    "slim_name": "bp_goslim_pombe"
                },
                {
                    "filter_type": "throughput",
                    "display_name": "Evidence type",
                    "scope": [
                        "gene",
                        "term",
                        "genotype",
                        "reference"
                    ],
                    "detailed_view_only": true,
                    "throughput_categories": [
                        {
                            "display_name": "High throughput experiment",
                            "throughput_type": "high"
                        },
                        {
                            "display_name": "Low throughput experiment",
                            "throughput_type": "low"
                        },
                        {
                            "display_name": "All experimental annotation",
                            "throughput_type": "high|low"
                        },
                        {
                            "display_name": "Inferred",
                            "throughput_type": "non-experimental"
                        }
                    ]
                }
            ],
            "help_route": "/documentation/gene-page-gene-ontology"
        },
        "cellular_component": {
            "feature_type": "gene",
            "display_name": "GO cellular component",
            "menu_item_label": "Cellular component",
            "columns_to_show": [
                "term_id",
                "desc-rel",
                "gene",
                "evidence",
                "qualifiers",
                "reference",
                "count",
                "extension"
            ],
            "external_db_link_keys": [
                "AmiGO",
                "QuickGO",
                "BioPortal"
            ],
            "slim_subset_name": "cc_goslim_pombe",
            "slim_description": "Cellular component overview (GO slim)",
            "slim_link": "/browse-curation/fission-yeast-cc-go-slim-terms",
            "slim_no_category_text": "cellular component GO Slim category",
            "ontology_graph_url": "https://www.ebi.ac.uk/QuickGO/services/ontology/go/terms/{ids}/chart?base64=false&showKey=true&showIds=true&termBoxWidth=120&termBoxHeight=65&showSlimColours=false&showChildren=true&fontSize=11&ids=",
            "summary_relation_ranges_to_collect": [
                "coincident_with",
                "during",
                "exists_during",
                "happens_during"
            ],
            "filters": [
                {
                    "filter_type": "extension",
                    "filter_subtype": "during",
                    "display_name": "During",
                    "scope": [
                        "gene",
                        "term",
                        "genotype",
                        "reference"
                    ],
                    "detailed_view_only": true,
                    "extension_rel_type_names": [
                        "during",
                        "happens_during",
                        "exists_during"
                    ]
                },
                {
                    "filter_type": "term",
                    "display_name": "Slim term",
                    "scope": [
                        "gene",
                        "reference"
                    ],
                    "detailed_view_only": false,
                    "slim_name": "cc_goslim_pombe"
                },
                {
                    "filter_type": "throughput",
                    "display_name": "Evidence type",
                    "scope": [
                        "gene",
                        "term",
                        "genotype",
                        "reference"
                    ],
                    "detailed_view_only": true,
                    "throughput_categories": [
                        {
                            "display_name": "High throughput experiment",
                            "throughput_type": "high"
                        },
                        {
                            "display_name": "Low throughput experiment",
                            "throughput_type": "low"
                        },
                        {
                            "display_name": "All experimental annotation",
                            "throughput_type": "high|low"
                        },
                        {
                            "display_name": "Inferred",
                            "throughput_type": "non-experimental"
                        }
                    ]
                }
            ],
            "help_route": "/documentation/gene-page-gene-ontology"
        },
        "PSI-MOD": {
            "feature_type": "gene",
            "display_name": "Modification",
            "protein_viewer_type": "modifications",
            "columns_to_show": [
                "term_id",
                "desc-rel",
                "gene",
                "evidence",
                "reference",
                "count",
                "extension"
            ],
            "external_db_link_keys": [
                "BioPortal"
            ],
            "sort_details_by": [
                "extension"
            ],
            "summary_relation_ranges_to_collect": [
                "residue",
                "modified residue"
            ],
            "modification_abbreviations": {
                "SPBC28F2.12": {
                    "CTD_S2": "S1559,S1566,S1579,S1586,S1593,S1600,S1607,S1614,S1621,S1628,S1635,S1642,S1649,S1656,S1663,S1670,S1677,S1684,S1691,S1698,S1705,S1712,S1719,S1726,S1733,S1740,S1747",
                    "CTD_T4": "T1554,T1567,T1581,T1588,T1595,T1602,T1609,T1616,T1623,T1630,T1637,T1644,T1651,T1658,T1665,T1672,T1679,T1686,T1693,T1700,T1707,T1714,T1721,T1728,T1735,T1742,T1749",
                    "CTD_S5": "S1555,S1562,S1568,S1575,S1582,S1589,S1596,S1603,S1610,S1617,S1624,S1631,S1638,S1645,S1652,S1659,S1666,S1673,S1680,S1687,S1694,S1701,S1708,S1715,S1722,S1729,S1736,S1743,S1750",
                    "CTD_S7": "S1557,S1577,S1584,S1591,S1598,S1605,S1612,S1619,S1626,S1633,S1640,S1647,S1654,S1661,S1668,S1675,S1682,S1689,S1696,S1703,S1710,S1717,S1724,S1731,S1738,S1745,S1752"
                }
            },
            "gene_structure_change_message": ["Warning: The translation start or intron/exon structure of this gene has changed since the genome was published (see Gene structure history section for change details).", "Changed Modification positions from older studies have been revised to match their current amino acid location."],
            "filters": [
                {
                    "filter_type": "throughput",
                    "display_name": "Throughput",
                    "scope": [
                        "gene",
                        "term",
                        "genotype",
                        "reference"
                    ],
                    "detailed_view_only": true,
                    "throughput_categories": [
                        {
                            "display_name": "High",
                            "throughput_type": "high"
                        },
                        {
                            "display_name": "Low",
                            "throughput_type": "low"
                        },
                        {
                            "display_name": "Non-experimental",
                            "throughput_type": "non-experimental"
                        }
                    ]
                }
            ],
            "help_route": "/documentation/gene-page-modifications"
        },
        "qualitative_gene_expression": {
            "feature_type": "gene",
            "display_name": "Qualitative gene expression",
            "menu_item_label": "Qualitative",
            "columns_to_show": [
                "desc-rel",
                "gene",
                "evidence",
                "reference",
                "count",
                "extension"
            ],
            "filters": [
                {
                    "filter_type": "extension",
                    "filter_subtype": "during",
                    "display_name": "During",
                    "scope": [
                        "gene",
                        "term",
                        "genotype",
                        "reference"
                    ],
                    "detailed_view_only": true,
                    "extension_rel_type_names": [
                        "during",
                        "happens_during",
                        "exists_during"
                    ]
                },
                {
                    "filter_type": "throughput",
                    "display_name": "Throughput",
                    "scope": [
                        "gene",
                        "term",
                        "genotype",
                        "reference"
                    ],
                    "detailed_view_only": true,
                    "throughput_categories": [
                        {
                            "display_name": "High",
                            "throughput_type": "high"
                        },
                        {
                            "display_name": "Low",
                            "throughput_type": "low"
                        },
                        {
                            "display_name": "Non-experimental",
                            "throughput_type": "non-experimental"
                        }
                    ]
                }
            ]
        },
        "quantitative_gene_expression": {
            "feature_type": "gene",
            "display_name": "Quantitative gene expression",
            "menu_item_label": "Quantitative",
            "filters": [
                {
                    "filter_type": "extension",
                    "filter_subtype": "during",
                    "display_name": "During",
                    "scope": [
                        "gene",
                        "term",
                        "genotype",
                        "reference"
                    ],
                    "detailed_view_only": true,
                    "extension_rel_type_names": [
                        "during",
                        "happens_during",
                        "exists_during"
                    ]
                },
                {
                    "filter_type": "throughput",
                    "display_name": "Throughput",
                    "scope": [
                        "gene",
                        "term",
                        "genotype",
                        "reference"
                    ],
                    "detailed_view_only": true,
                    "throughput_categories": [
                        {
                            "display_name": "High",
                            "throughput_type": "high"
                        },
                        {
                            "display_name": "Low",
                            "throughput_type": "low"
                        },
                        {
                            "display_name": "Non-experimental",
                            "throughput_type": "non-experimental"
                        }
                    ]
                }
            ]
        },
        "mondo": {
            "feature_type": "gene",
            "display_name": "Disease association",
            "columns_to_show": [
                "term_id",
                "desc-rel",
                "gene",
                "qualifiers",
                "term-xref",
                "reference",
                "count"
            ],
            "external_db_link_keys": [
                "Monarch Disease Ontology"
            ],
            "source_config": {
                "MalaCards": {
                    "display_name_prop": "malacards_displayed_disease_name",
                    "id_source": "prop_name:malacards_disease_slug",
                    "condition": "reference=PMID:27899610"
                },
                "Monarch": {
                    "id_source": "ACCESSION",
                    "condition": "reference=PB_REF:0000006"
                },
                "PomBase": {
                    "condition": "reference=PB_REF:0000003"
                },
                "Cancer census": {
                    "condition": "reference=PMID:30371878"
                }
            },
            "slim_subset_name": "pombe_mondo_slim",
            "slim_description": "Disease ontology overview",
            "slim_link": "/browse-curation/disease-slim",
            "slim_no_category_text": "disease ontology overview category",
            "filters": [
                {
                    "filter_type": "term",
                    "display_name": "Slim term",
                    "scope": [
                        "gene",
                        "reference"
                    ],
                    "detailed_view_only": false,
                    "slim_name": "pombe_mondo_slim"
                }
            ]
        },
        "species_dist": {
            "feature_type": "gene",
            "display_name": "Taxonomic conservation",
            "columns_to_show": [
                "term_id",
                "desc-rel",
                "gene",
                "count"
            ],
            "hideTermDetails": "true",
            "help_route": "/documentation/taxonomic-conservation"
        },
        "ex_tools": {
            "display_name": "Experimental tools",
            "feature_type": "gene",
            "columns_to_show": [
                "term_id",
                "gene",
                "reference",
                "count"
            ],
            "details_only": true
        },
        "cat_act": {
            "feature_type": "gene",
            "display_name": "Catalytic activity attributes",
            "columns_to_show": [
                "term_id",
                "gene",
                "reference",
                "count"
            ],
            "details_only": true
        },
        "genome_org": {
            "feature_type": "gene",
            "display_name": "Genome organisation",
            "columns_to_show": [
                "term_id",
                "gene",
                "reference",
                "count"
            ],
            "details_only": true
        },
        "misc": {
            "feature_type": "gene",
            "display_name": "Comment",
            "columns_to_show": [
                "term_id",
                "gene",
                "evidence",
                "reference",
                "count"
            ],
            "details_only": true
        },
        "m_f_g": {
            "feature_type": "gene",
            "display_name": "Miscellaneous functional group",
            "columns_to_show": [
                "term_id",
                "gene",
                "evidence",
                "count"
            ],
            "details_only": true
        },
        "complementation": {
            "feature_type": "gene",
            "display_name": "Complementation",
            "columns_to_show": [
                "term_id",
                "desc-rel",
                "gene",
                "evidence",
                "qualifiers",
                "reference",
                "count",
                "extension"
            ]
        },
        "transcript_view": {
            "feature_type": "gene",
            "display_name": "Transcript details"
        },
        "protein_domains_and_properties": {
            "feature_type": "gene",
            "display_name": "Protein domains and features"
        },
        "pombase_family_or_domain": {
            "feature_type": "gene",
            "display_name": "Protein features",
            "details_only": true,
            "no_gene_details_section": true,
            "columns_to_show": [
                "term_id",
                "gene",
                "count",
                "reference"
            ]
        },
        "PomBase gene characterisation status": {
            "feature_type": "gene",
            "display_name": "gene characterisation status"
        },
        "target_of": {
            "feature_type": "gene",
            "display_name": "Target of"
        },
        "genetic_interactions": {
            "feature_type": "gene",
            "display_name": "Genetic interaction",
            "columns_to_show": [
                "gene",
                "gene-product",
                "interactor",
                "interactor-product",
                "evidence",
                "reference"
            ],
            "filters": [
                {
                    "filter_type": "throughput",
                    "display_name": "Throughput",
                    "throughput_categories": [
                        {
                            "display_name": "High",
                            "throughput_type": "high"
                        },
                        {
                            "display_name": "Low",
                            "throughput_type": "low"
                        }
                    ]
                },
                {
                    "filter_type": "interaction_type",
                    "display_name": "Interaction Type",
                    "interaction_types": [
                        "Dosage Growth Defect",
                        "Dosage Lethality",
                        "Dosage Rescue",
                        "Negative Genetic",
                        "Phenotypic Enhancement",
                        "Phenotypic Suppression",
                        "Positive Genetic",
                        "Synthetic Growth Defect",
                        "Synthetic Lethality",
                        "Synthetic Rescue"
                    ]
                }
            ]
        },
        "double_mutant_genetic_interactions": {
            "feature_type": "gene",
            "display_name": "Double allele interactions",
            "inherits_from": "genetic_interactions"
        },
        "single_allele_genetic_interactions": {
            "feature_type": "gene",
            "display_name": "Single allele interactions",
            "inherits_from": "genetic_interactions"
        },
        "physical_interactions": {
            "feature_type": "gene",
            "display_name": "Physical interaction",
            "columns_to_show": [
                "gene",
                "gene-product",
                "interactor",
                "interactor-product",
                "evidence",
                "reference"
            ],
            "filters": [
                {
                    "filter_type": "throughput",
                    "display_name": "Throughput",
                    "throughput_categories": [
                        {
                            "display_name": "High",
                            "throughput_type": "high"
                        },
                        {
                            "display_name": "Low",
                            "throughput_type": "low"
                        }
                    ]
                }
            ]
        },
        "orthologs": {
            "feature_type": "gene",
            "display_name": "Orthologs",
            "columns_to_show": [
                "species",
                "ortholog",
                "description"
            ]
        },
        "paralogs": {
            "feature_type": "gene",
            "display_name": "Paralogs",
            "columns_to_show": [
                "ortholog",
                "description"
            ]
        },
        "subunit_composition": {
            "feature_type": "gene",
            "display_name": "Subunit composition",
            "columns_to_show": [
                "term_id",
                "desc-rel",
                "gene",
                "evidence",
                "qualifiers",
                "reference",
                "count",
                "extension"
            ]
        },
        "sequence": {
            "feature_type": "gene",
            "display_name": "Protein sequence feature",
            "columns_to_show": [
                "term_id",
                "desc-rel",
                "gene",
                "evidence",
                "qualifiers",
                "residue",
                "reference",
                "count",
                "extension"
            ],
            "external_db_link_keys": [
                "MISO"
            ],
            "no_gene_details_section": true
        },
        "warning": {
            "feature_type": "gene",
            "display_name": "Warnings",
            "columns_to_show": [
                "term_id",
                "desc-rel",
                "gene",
                "evidence",
                "qualifiers",
                "reference",
                "count",
                "extension"
            ]
        },
        "_DEFAULT_": {
            "feature_type": "gene",
            "display_name": null,
            "columns_to_show": [
                "term_id",
                "desc-rel",
                "gene",
                "evidence",
                "qualifiers",
                "reference",
                "count",
                "extension"
            ]
        }
    },
    "interaction_config": {
      "Co-crystal Structure": {
        "baitLabel": "co-crystallizes with",
        "preyLabel": "co-crystallizes with",
        "isSymmetric": true
      },
      "Co-fractionation": {
        "baitLabel": "co-fractionates with",
        "preyLabel": "co-fractionates with",
        "isSymmetric": true
      },
      "Co-localization": {
        "baitLabel": "co-localizes with",
        "preyLabel": "co-localizes with",
        "isSymmetric": true
      },
      "Co-purification": {
        "baitLabel": "co-purifies with",
        "preyLabel": "co-purifies with",
        "isSymmetric": true
      },
      "Reconstituted Complex": {
        "baitLabel": "forms complex with",
        "preyLabel": "forms complex with",
        "isSymmetric": true
      },
      "Affinity Capture-Luminescence": {
        "baitLabel": "affinity captures",
        "preyLabel": "affinity captured by",
        "isSymmetric": false
      },
      "Affinity Capture-MS": {
        "baitLabel": "affinity captures",
        "preyLabel": "affinity captured by",
        "isSymmetric": false
      },
      "Affinity Capture-RNA": {
        "baitLabel": "affinity captures",
        "preyLabel": "affinity captured by",
        "isSymmetric": false
      },
      "Affinity Capture-Western": {
        "baitLabel": "affinity captures",
        "preyLabel": "affinity captured by",
        "isSymmetric": false
      },
      "Proximity Label-MS": {
        "baitLabel": "affinity captures",
        "preyLabel": "affinity captured by",
        "isSymmetric": false
      },
      "Biochemical Activity": {
        "baitLabel": "modifies",
        "preyLabel": "modified by",
        "isSymmetric": false
      },
      "Far Western": {
        "baitLabel": "captures",
        "preyLabel": "captured by",
        "isSymmetric": false
      },
      "FRET": {
        "baitLabel": "fluorescence resonance energy donor to",
        "preyLabel": "fluorescence resonance energy acceptor from",
        "isSymmetric": false
      },
      "PCA": {
        "baitLabel": "interacts with",
        "preyLabel": "interacts with",
        "isSymmetric": true
      },
      "Protein-peptide": {
        "baitLabel": "binds to peptide derived from",
        "preyLabel": "peptide from this protein binds to",
        "isSymmetric": false
      },
      "Protein-RNA": {
        "baitLabel": "binds to RNA",
        "preyLabel": "binds to protein",
        "isSymmetric": false
      },
      "Two-hybrid": {
        "baitLabel": "binds activation domain construct with",
        "preyLabel": "binds DNA-binding domain construct with",
        "isSymmetric": false
      },
      "Negative Genetic": {
        "baitLabel": "negative genetic interaction with",
        "preyLabel": "negative genetic interaction with",
        "isSymmetric": true
      },
      "Positive Genetic": {
        "baitLabel": "positive genetic interaction with",
        "preyLabel": "positive genetic interaction with",
        "isSymmetric": true
      },
      "Synthetic Growth Defect": {
        "baitLabel": "synthetic growth defect with",
        "preyLabel": "synthetic growth defect with",
        "isSymmetric": true
      },
      "Synthetic Haploinsufficiency": {
        "baitLabel": "synthetic haploinsufficient with",
        "preyLabel": "synthetic haploinsufficient with",
        "isSymmetric": true
      },
      "Synthetic Lethality": {
        "baitLabel": "synthetic lethal with",
        "preyLabel": "synthetic lethal with",
        "isSymmetric": true
      },
      "Synthetic Phenotype": {
        "baitLabel": "synthetically interacts with",
        "preyLabel": "synthetically interacts with",
        "isSymmetric": true
      },
      "Synthetic Rescue": {
        "baitLabel": "synthetically rescued by",
        "preyLabel": "synthetically rescues",
        "isSymmetric": false
      },
      "Dosage Growth Defect": {
        "baitLabel": "growth defect in presence of overexpressed",
        "preyLabel": "overexpression causes growth defect to",
        "isSymmetric": false
      },
      "Dosage Lethality": {
        "baitLabel": "inviable in presence of overexpressed",
        "preyLabel": "overexpression lethal to",
        "isSymmetric": false
      },
      "Dosage Rescue": {
        "baitLabel": "rescued by overexpression of",
        "preyLabel": "overexpression rescues",
        "isSymmetric": false
      },
      "Phenotypic Enhancement": {
        "baitLabel": "phenotype enhanced by",
        "preyLabel": "enhances phenotype of",
        "isSymmetric": false
      },
      "Phenotypic Suppression": {
        "baitLabel": "rescued by",
        "preyLabel": "rescues",
        "isSymmetric": false
      }
    },
    "target_of_config": {
        "ontology_labels": {
            "molecular_function": "GO",
            "biological_process": "GO",
            "cellular_component": "GO",
            "fission_yeast_phenotype": "FYPO",
            "single_locus_phenotype": "FYPO",
            "multi_locus_phenotype": "FYPO"
        },
        "relation_priority": {
            "dephosphorylated by": 25,
            "directly activated by": 20,
            "directly inhibited by": 20,
            "inhibited by": 18,
            "phosphorylated by": 15,
            "ubiquitinated by": 15,
            "chaperoned by": 15,
            "activated by": 15,
            "recruited by": 15,
            "anchored by": 15,
            "sequestered by": 15,
            "activity regulated by": 13,
            "substrate of": 12,
            "promoter bound by": 11,
            "read by": 11,
            "binds": 10,
            "transported by": 9,
            "localized by": 8,
            "transcription activated by": 7,
            "transcription repressed by": 7,
            "transcription regulated by": 7,
            "regulated by": 6,
            "sensed by": 5,
            "localization affected by mutation in": 4,
            "activity affected by mutation in": 3,
            "affected by mutation in": 2
        }
    },
    "phenotype_id_prefixes": [
        "FYPO"
    ],
    "annotation_type_order": [
        { "name": "Gene Ontology",
          "sub_types": ["molecular_function", "biological_process", "cellular_component" ]
        },
        { "name": "target_of" },
        { "name": "phenotype",
          "sub_types": ["single_locus_phenotype", "multi_locus_phenotype"]
        },
        { "name": "fission_yeast_phenotype_condition" },
        { "name": "complementation" },
        { "name": "protein_domains_and_properties" },
        { "name": "PSI-MOD" },
        { "name": "expression",
          "sub_types": ["qualitative_gene_expression", "quantitative_gene_expression"] },
        { "name": "pombase_family_or_domain" },
        { "name": "cat_act" },
        { "name": "m_f_g" },
        { "name": "genome_org" },
        { "name": "ex_tools" },
        { "name": "sequence and transcripts",
          "sub_types": ["transcript_view", "transcript-sequence"]
        },
        { "name": "sequence" },
        { "name": "interactions",
          "sub_types": ["physical_interactions", "genetic_interactions"]
        },
        { "name": "double_mutant_genetic_interactions" },
        { "name": "single_allele_genetic_interactions" },
        { "name": "mondo" },
        { "name": "homologs and conservation",
          "sub_types": ["orthologs", "paralogs", "species_dist"]
        },
        { "name": "Comments and warnings",
          "sub_types": ["misc", "warning"] },
        { "name": "subunit_composition" }
    ],
    "interesting_parents": [
        {
            "termid": "GO:0005515",
            "rel_name": "is_a"
        },
        {
            "termid": "GO:0003723",
            "rel_name": "is_a"
        },
        {
            "termid": "GO:0032991",
            "rel_name": "is_a"
        },
        {
            "termid": "GO:0032991",
            "rel_name": "part_of"
        },
        {
            "termid": "SO:0000839",
            "rel_name": "is_a"
        },
        {
            "termid": "GO:0000786",
            "rel_name": "is_a"
        }
    ],
    "external_gene_references": [
        {
            "ref_type": "Sequence Resources",
            "feature_types": [
                "rRNA gene",
                "tRNA gene",
                "snRNA gene",
                "snoRNA gene",
                "lncRNA gene",
                "sncRNA gene",
                "ncRNA gene"
            ],
            "name": "RNAcentral",
            "description": "Non-coding RNA sequence database",
            "field_name": "rnacentral_urs_identifier",
            "url": "https://rnacentral.org/rna/<<IDENTIFIER>>/<<TAXONID>>"
        },
        {
            "ref_type": "Sequence resources",
            "feature_types": [
                "mRNA gene",
                "pseudogene"
            ],
            "name": "UniProtKB/SwissProt",
            "description": "Protein database ",
            "field_name": "uniprot_identifier",
            "go_xrf_abbrev": "UniProtKB"
        },
        {
            "ref_type": "Sequence resources",
            "feature_types": [
                "mRNA gene"
            ],
            "name": "InterPro",
            "description": "Classification of protein families",
            "field_name": "uniprot_identifier",
            "go_xrf_abbrev": "InterProUniProtId"
        },
        {
            "ref_type": "Sequence resources",
            "feature_types": [
                "ALL"
            ],
            "name": "NCBI",
            "description": "Query all NCBI databases",
            "field_name": "NCBI_ALL_IDS",
            "url": "https://www.ncbi.nlm.nih.gov/gquery/?term=(<<IDENTIFIER>>)+AND+(pombe+OR+fission+yeast)"
        },
        {
            "ref_type": "Sequence resources",
            "feature_types": [
                "ALL"
            ],
            "name": "Ensembl",
            "description": "Genome browser",
            "field_name": "uniquename",
            "url": "http://fungi.ensembl.org/Schizosaccharomyces_pombe/Location/View?db=core;g=<<IDENTIFIER>>"
        },
        {
            "ref_type": "Phenotype resources",
            "feature_types": [
                "mRNA gene"
            ],
            "name": "Monarch",
            "description": "Phenotype driven discovery",
            "field_name": "uniquename",
            "go_xrf_abbrev": "Monarch"
        },
        {
            "ref_type": "Structure",
            "feature_types": [
                "mRNA gene"
            ],
            "name": "AlphaFold",
            "description": "AlphaFold structure predictions",
            "field_name": "uniprot_identifier",
            "go_xrf_abbrev": "AlphaFold"
        },
        {
            "ref_type": "Structure",
            "feature_types": [
                "mRNA gene"
            ],
            "name": "PDB",
            "constraint": "pdb_entries",
            "description": "Experiment structure predictions",
            "field_name": "uniprot_identifier",
            "url": "https://www.ebi.ac.uk/pdbe/entry/search/index/?searchParams=%7B%22q_uniprot%22:%5B%7B%22value%22:%22<<IDENTIFIER>>%22,%22condition1%22:%22AND%22,%22condition2%22:%22Contains%22%7D%5D,%22resultState%22:%7B%22tabIndex%22:0,%22paginationIndex%22:1,%22perPage%22:%2210%22,%22sortBy%22:%22Sort%20by%22%7D%7D"
        },
        {
            "ref_type": "Structure",
            "feature_types": [
                "mRNA gene",
                "pseudogene"
            ],
            "name": "ModBase",
            "description": "Comparative protein structure models",
            "field_name": "uniprot_identifier",
            "go_xrf_abbrev": "ModBase"
        },
        {
            "ref_type": "Structure",
            "feature_types": [
                "mRNA gene",
                "pseudogene"
            ],
            "name": "SWISS-MODEL Repository",
            "description": "Automated protein structure homology modelling",
            "field_name": "uniprot_identifier",
            "url": "https://swissmodel.expasy.org/repository/uniprot/<<IDENTIFIER>>"
        },
        {
            "ref_type": "Localization",
            "feature_types": [
                "ALL"
            ],
            "name": "SPD / RIKEN",
            "description": "Riken Orfeome Localization Data",
            "field_name": "orfeome_identifier",
            "url": "http://www.riken.jp/SPD/<<IDENTIFIER>>.html"
        },
        {
            "ref_type": "Complexes",
            "feature_types": [
                "ALL"
            ],
            "name": "Complex Portal",
            "description": "Macromolecular complex database",
            "field_name": "complex_portal_ids",
            "url": "https://www.ebi.ac.uk/complexportal/complex/search?query=<<UNIPROT_ACCESSION>>"
        },
        {
            "ref_type": "Strain and reagents",
            "feature_types": [
                "ALL"
            ],
            "name": "National BioResource Project (NBRP)",
            "description": "Strains and clones",
            "field_name": "uniquename",
            "url": "http://viewer.shigen.info/yeastvw/wordsearch/search?fuzzy=y&action=mapview&ysttype=f&word=<<IDENTIFIER>>"
        },
        {
            "ref_type": "Strain and reagents",
            "feature_types": [
                "ALL"
            ],
            "name": "Image Data Resource",
            "description": "Microscopy data",
            "field_name": "uniquename",
            "url": "https://idr.openmicroscopy.org/mapr/gene/?value=<<IDENTIFIER>>"
        },
        {
            "ref_type": "Cloning",
            "feature_types": [
                "ALL"
            ],
            "name": "OpenCloning",
            "description": "Plan and document cloning and genome engineering",
            "field_name": "uniquename",
            "url": "http://app.opencloning.org/?source=locus_tag&assembly_accession=GCA_000002945.3&locus_tag=<<IDENTIFIER>>",
            "show_in_sections": ["transcript-sequence"]
        },
        {
            "ref_type": "GO annotation",
            "feature_types": [
                "mRNA gene"
            ],
            "name": "QuickGO",
            "field_name": "uniprot_identifier",
            "description": "QuickGO Gene Ontology annotation viewer",
            "url": "https://www.ebi.ac.uk/QuickGO/annotations?geneProductId=<<IDENTIFIER>>"
        },
        {
            "ref_type": "GO annotation",
            "feature_types": [
                "mRNA gene"
            ],
            "name": "AmiGO",
            "field_name": "uniquename",
            "description": "GO Consortium browser",
            "url": "http://amigo.geneontology.org/amigo/gene_product/PomBase:<<IDENTIFIER>>"
        },
        {
            "ref_type": "Interactions",
            "feature_types": [
                "ALL"
            ],
            "name": "BioGRID",
            "description": "Physical and genetic interactions",
            "field_name": "biogrid_interactor_id",
            "url": "https://thebiogrid.org/<<IDENTIFIER>>/summary/schizosaccharomyces-pombe/<<GENE_NAME>>.html"
        },
        {
            "ref_type": "Interactions",
            "feature_types": [
                "ALL"
            ],
            "name": "STRING",
            "description": "Network display of known and predicted interactions and functional associations",
            "field_name": "uniprot_identifier",
            "url": "https://string-db.org/cgi/network.pl?species=4896&identifier=<<IDENTIFIER>>"
        },
        {
            "ref_type": "Interactions",
            "feature_types": [
                "mRNA gene"
            ],
            "name": "IntAct",
            "description": "IntAct Interaction Network",
            "field_name": "uniprot_identifier",
            "go_xrf_abbrev": "IntactInteractionNetwork"
        },
        {
            "ref_type": "Interactions",
            "feature_types": [
                "mRNA gene"
            ],
            "name": "TFexplorer IPMS",
            "description": "Experimentally determined transcription factor (TF) interactions (IP-MS)",
            "field_name": "tfexplorer_ipms_identifier",
            "url": "https://data.fmi.ch/TFexplorer/pombe.html?tf=<<IDENTIFIER>>"
        },
        {
            "ref_type": "Interactions",
            "feature_types": [
                "mRNA gene"
            ],
            "name": "TFexplorer ChIP–seq",

            "description": "Experimentally determined transcription factor (TF) interactions (ChIP-Seq)",
            "field_name": "tfexplorer_chipseq_identifier",
            "url": "https://data.fmi.ch/TFexplorer/pombe.html?tf=<<IDENTIFIER>>"
        },
        {
            "ref_type": "Modifications",
            "feature_types": [
                "mRNA gene"
            ],
            "name": "iPTMnet",
            "description": "Protein modifications",
            "field_name": "uniprot_identifier",
            "go_xrf_abbrev": "iPTMnet"
        },
        {
            "ref_type": "Modifications",
            "feature_types": [
                "mRNA gene"
            ],
            "name": "Martin Lab (Bérard et al 2024)",
            "constraint": "pombephosphoproteomics_unige_ch_starvation_mating_gene",
            "description": "Phosphorylation changes during sexual reproduction, starvation/mating",
            "field_name": "uniprot_identifier",
            "url": "https://pombephosphoproteomics.unige.ch/protein/<<IDENTIFIER>>/starvation-mating"
        },
        {
            "ref_type": "Modifications",
            "feature_types": [
                "mRNA gene"
            ],
            "name": "Martin Lab (Bérard et al 2024)",
            "constraint": "pombephosphoproteomics_unige_ch_fusion_gene",
            "description": "Phosphorylation changes during sexual reproduction, cell-cell fusion",
            "field_name": "uniprot_identifier",
            "url": "https://pombephosphoproteomics.unige.ch/protein/<<IDENTIFIER>>/cell-cell-fusion"
        },
        {
            "ref_type": "Expression",
            "feature_types": [
                "ALL"
            ],
            "name": "Gene Expression Omnibus",
            "description": "GEO profiles",
            "field_name": "uniquename",
            "url": "https://www.ncbi.nlm.nih.gov/geoprofiles/?term=<<IDENTIFIER>>"
        },
        {
            "ref_type": "Expression",
            "feature_types": [
                "ALL"
            ],
            "name": "pombeTV (v1)",
            "description": "Tiling array & Illumina sequencing profiles",
            "field_name": "uniquename",
            "url": "http://bahlerweb.cs.ucl.ac.uk/cgi-bin/pombetv/pombetv?condition=13&action=display&genename=<<IDENTIFIER>>"
        },
        {
            "ref_type": "Expression",
            "feature_types": [
                "ALL"
            ],
            "name": "pombeNcTV (pombeTV v2)",
            "description": "Illumina RNA sequencing profiles",
            "field_name": "uniquename",
            "url": "http://bahlerweb.cs.ucl.ac.uk/cgi-bin/nctv/nctv?genename=<<IDENTIFIER>>&action=Display"
        },
        {
            "ref_type": "Expression",
            "feature_types": [
                "ALL"
            ],
            "name": "Bähler Expression viewer",
            "description": "RNA expression during the cell cycle",
            "field_name": "uniquename",
            "url": "http://bahlerweb.cs.ucl.ac.uk/cgi-bin/SPGE/geexview?group=4&scale=log2&scale_min=-2&scale_max=2&q=<<IDENTIFIER>>"
        },
        {
            "ref_type": "Expression",
            "feature_types": [
                "ALL"
            ],
            "name": "Bähler Expression viewer",
            "description": "RNA expression during stress",
            "field_name": "uniquename",
            "url": "http://bahlerweb.cs.ucl.ac.uk/cgi-bin/SPGE/geexview?group=3&scale=log2&scale_min=-2&scale_max=2&q=<<IDENTIFIER>>"
        },
        {
            "ref_type": "Expression",
            "feature_types": [
                "ALL"
            ],
            "name": "Bähler Expression viewer",
            "description": "RNA expression during meiosis",
            "field_name": "uniquename",
            "url": "http://bahlerweb.cs.ucl.ac.uk/cgi-bin/SPGE/geexview?group=2&scale=log2&scale_min=-2&scale_max=2&q=<<IDENTIFIER>>"
        },
        {
            "ref_type": "Expression",
            "feature_types": [
                "ALL"
            ],
            "name": "Bähler Expression viewer",
            "description": "RNA expression during mating",
            "field_name": "uniquename",
            "url": "http://bahlerweb.cs.ucl.ac.uk/cgi-bin/SPGE/geexview?group=1&scale=log2&scale_min=-2&scale_max=2&q=<<IDENTIFIER>>"
        },
        {
            "ref_type": "Expression",
            "feature_types": [
                "mRNA gene"
            ],
            "name": "Cyclebase",
            "description": "Genome-wide cell-cycle-related experimental results",
            "field_name": "uniquename",
            "url": "https://cyclebase.org/CyclebasePage?type=4896&id=<<IDENTIFIER>>.1"
        },
        {
            "ref_type": "Expression",
            "feature_types": [
                "mRNA gene"
            ],
            "name": "Butter Lab (Öztürk et al. 2022)",
            "description": "Changes in protein level of this gene product when deleting other protein coding genes",
            "field_name": "uniquename",
            "url": "https://butterlab.imb-mainz.de/SpProtQuant/?data=KOLibrary&data2=searchByProtein&protein=<<IDENTIFIER>>"
        },
        {
            "ref_type": "Expression",
            "feature_types": [
                "mRNA gene"
            ],
            "name": "Butter Lab (Öztürk et al. 2022)",
            "description": "Proteomic changes resulting from the deletion of this gene",
            "field_name": "uniquename",
            "url": "https://butterlab.imb-mainz.de/SpProtQuant/?data=KOLibrary&data2=searchByKOStrain&KOStrain=<<IDENTIFIER>>"
        },
        {
            "ref_type": "Proteomics",
            "feature_types": [
                "mRNA gene",
                "pseudogene"
            ],
            "name": "PeptideAtlas",
            "description": "Peptides identified in tandem mass spectrometry",
            "field_name": "uniquename",
            "url": "https://db.systemsbiology.net/sbeams/cgi/PeptideAtlas/GetProtein?action=QUERY&atlas_build_id=355&protein_name=<<IDENTIFIER>>"
        },
        {
            "ref_type": "Pathways",
            "feature_types": [
                "mRNA gene",
                "pseudogene"
            ],
            "name": "Reactome",
            "description": "Manually curated and peer-reviewed pathways",
            "field_name": "uniprot_identifier",
            "url": "https://reactome.org/content/query?q=<<IDENTIFIER>>"
        },
        {
            "ref_type": "Orthologs",
            "feature_types": [
                "mRNA gene",
                "pseudogene"
            ],
            "name": "SOG",
            "description": "Schizosaccharomyces OrthoGroup - orthologs, gene trees, alignments, synteny (Schizosaccharomyces)",
            "field_name": "schizosaccharomyces_orthogroup",
            "show_in_sections": [
                "orthologs"
            ],
            "url": "https://www.sogweb.org/iSOG/<<IDENTIFIER>>.html"
        },
        {
            "ref_type": "Orthologs",
            "feature_types": [
                "mRNA gene",
                "pseudogene"
            ],
            "name": "OMA",
            "description": "Orthologous MAtrix - orthologs, gene trees, alignments (Fungal)",
            "field_name": "uniquename",
            "show_in_sections": [
                "orthologs"
            ],
            "url": "https://omabrowser.org/oma/hogs/<<IDENTIFIER>>/Fungi/"
        },
        {
            "ref_type": "Orthologs",
            "feature_types": [
                "mRNA gene",
                "pseudogene"
            ],
            "name": "Ensembl Fungal Compara",
            "description": "Orthologs, gene trees, alignments",
            "field_name": "uniquename",
            "show_in_sections": [
                "orthologs"
            ],
            "url": "http://fungi.ensembl.org/Schizosaccharomyces_pombe/Gene/Compara?db=core;g=<<IDENTIFIER>>"
        },
        {
            "ref_type": "Orthologs",
            "feature_types": [
                "mRNA gene",
                "pseudogene"
            ],
            "name": "PANTHER",
            "description": "Orthologs, gene trees, alignments (selected species, pan kingdom, eukaryotic focus)",
            "field_name": "uniprot_identifier",
            "show_in_sections": [
                "orthologs"
            ],
            "url": "http://www.pantherdb.org/genes/gene.do?acc=SCHPO%7CPomBase%3D<<UNIQUENAME>>%7CUniProtKB%3D<<IDENTIFIER>>"
        },
        {
            "ref_type": "Orthologs",
            "feature_types": [
                "mRNA gene",
                "pseudogene"
            ],
            "name": "DIOPT",
            "description": "DRSC Integrative Ortholog Prediction Tool - Integrated ortholog predictors (eukaryotic model species focus)",
            "field_name": "uniquename",
            "show_in_sections": [
                "orthologs"
            ],
            "url": "http://www.flyrnai.org/cgi-bin/DRSC_orthologs.pl?input_species=4896&output_species=0&additional_filter=None&search_fields=***&search_datasets=***&gene_list=<<IDENTIFIER>>"
        },
        {
            "ref_type": "Orthologs",
            "feature_types": [
                "mRNA gene",
                "pseudogene"
            ],
            "name": "HCOP",
            "description": "Integrated ortholog predictors (human focus)",
            "field_name": "uniquename",
            "show_in_sections": [
                "orthologs"
            ],
            "url": "https://www.genenames.org/tools/hcop/#!/?q=<<IDENTIFIER>>&qtype=pombase&qtax_id=284812&ttax_id=9606&submit=true"
        },
        {
            "ref_type": "Orthologs",
            "feature_types": [
                "mRNA gene",
                "pseudogene"
            ],
            "name": "Ensembl Pan-taxonomic Compara",
            "description": "Orthologs, gene trees (174 selected species, pan kingdom)",
            "field_name": "uniquename",
            "show_in_sections": [
                "orthologs"
            ],
            "url": "http://fungi.ensembl.org/Schizosaccharomyces_pombe/Gene/PanCompara?db=core;g=<<IDENTIFIER>>"
        },
        {
            "ref_type": "Promoters",
            "feature_types": [
                "ALL"
            ],
            "name": "Eukaryotic Promoter Database",
            "description": "Experimentally validated promoters",
            "field_name": "uniquename",
            "url": "http://epd.vital-it.ch/search_EPDnew.php?db=S_pombe&query=<<IDENTIFIER>>"
        }
    ],
    "external_term_references": [
        {
            "name": "BioPortal",
            "url": "https://purl.bioontology.org/ontology/[conf_db_prefix]?conceptid=http%3A%2F%2Fpurl.obolibrary.org%2Fobo%2F[conf_db_prefix]_[id_no_prefix]"
        },
        {
            "name": "MISO",
            "url": "http://www.sequenceontology.org/browser/current_svn/term/[example_id]"
        },
        {
            "name": "Reactome",
            "url": "https://reactome.org/content/query?species=Schizosaccharomyces+pombe&q=[example_id]"
        },
        {
            "name": "Monarch Disease Ontology",
            "url": "https://monarchinitiative.org/disease/[example_id]"
        }
    ],
    "external_term_link_prefixes": [
        "CHEBI",
        "CL"
    ],
    "viability_terms": {
        "viable": "FYPO:0002060",
        "inviable": "FYPO:0002061"
    },
    "slims": {
        "cc_goslim_pombe": {
            "slim_display_name": "Cellular Component slim",
            "doc_path": "/documentation/pombase-go-slim-documentation",
            "full_slim_path": "/browse-curation/fission-yeast-cc-go-slim-terms",
            "description": "S. pombe high level GO cellular component terms",
            "slim_results_description": "A \"GO slim\" is a subset of the Gene Ontology terms selected for a specific purpose in interpreting the functional annotations in an entire organism, or a gene product list derived from an experiment.",
            "cv_name": "cellular_component",
            "terms": [
                {
                    "name": "cytosol",
                    "termid": "GO:0005829"
                },
                {
                    "name": "cytoplasmic vesicle",
                    "termid": "GO:0031410"
                },
                {
                    "name": "division septum",
                    "termid": "GO:0000935"
                },
                {
                    "name": "prospore membrane",
                    "termid": "GO:0005628"
                },
                {
                    "name": "extracellular region",
                    "termid": "GO:0005576"
                },
                {
                    "name": "cell surface",
                    "termid": "GO:0009986"
                },
                {
                    "name": "endoplasmic reticulum membrane",
                    "termid": "GO:0005789"
                },
                {
                    "name": "actin cytoskeleton",
                    "termid": "GO:0015629"
                },
                {
                    "name": "cytoplasmic stress granule",
                    "termid": "GO:0010494"
                },
                {
                    "name": "P-body",
                    "termid": "GO:0000932"
                },
                {
                    "name": "phagophore assembly site",
                    "termid": "GO:0000407"
                },
                {
                    "name": "peroxisome",
                    "termid": "GO:0005777"
                },
                {
                    "name": "Golgi apparatus",
                    "termid": "GO:0005794"
                },
                {
                    "name": "cell cortex",
                    "termid": "GO:0005938"
                },
                {
                    "name": "cell wall",
                    "termid": "GO:0005618"
                },
                {
                    "name": "cytosolic ribosome",
                    "termid": "GO:0022626"
                },
                {
                    "name": "actin cortical patch",
                    "termid": "GO:0030479"
                },
                {
                    "name": "nucleus",
                    "termid": "GO:0005634"
                },
                {
                    "name": "kinetochore",
                    "termid": "GO:0000776"
                },
                {
                    "name": "microtubule cytoskeleton",
                    "termid": "GO:0015630"
                },
                {
                    "name": "nuclear pore",
                    "termid": "GO:0005643"
                },
                {
                    "name": "nuclear periphery",
                    "termid": "GO:0034399"
                },
                {
                    "name": "nucleolus",
                    "termid": "GO:0005730"
                },
                {
                    "name": "nucleoplasm",
                    "termid": "GO:0005654"
                },
                {
                    "name": "endosome",
                    "termid": "GO:0005768"
                },
                {
                    "name": "vacuole",
                    "termid": "GO:0005773"
                },
                {
                    "name": "contractile ring",
                    "termid": "GO:0070938"
                },
                {
                    "name": "mitotic spindle",
                    "termid": "GO:0072686"
                },
                {
                    "name": "spindle pole body",
                    "termid": "GO:0005816"
                },
                {
                    "name": "endoplasmic reticulum",
                    "termid": "GO:0005783"
                },
                {
                    "name": "plasma membrane",
                    "termid": "GO:0005886"
                },
                {
                    "name": "mitochondrion",
                    "termid": "GO:0005739"
                },
                {
                    "name": "chromosome",
                    "termid": "GO:0005694"
                },
                {
                    "name": "preribosome",
                    "termid": "GO:0030684"
                }
            ]
        },
        "bp_goslim_pombe": {
            "slim_display_name": "Biological Process slim",
            "doc_path": "/documentation/pombase-go-slim-documentation",
            "full_slim_path": "/browse-curation/fission-yeast-bp-go-slim-terms",
            "description": "S. pombe high level GO biological process terms",
            "slim_results_description": "A \"GO slim\" is a subset of the Gene Ontology terms selected for a specific purpose in interpreting the functional annotations in an entire organism, or a gene product list derived from an experiment.  PomBase has created a GO slim to provide a simple summary of S. pombe's biological capabilities by grouping gene products using broad biological process classifiers.",
            "cv_name": "biological_process",
            "terms": [
                {
                    "name": "DNA recombination",
                    "termid": "GO:0006310"
                },
                {
                    "name": "DNA repair",
                    "termid": "GO:0006281"
                },
                {
                    "name": "DNA replication",
                    "termid": "GO:0006260"
                },
                {
                    "name": "actin cytoskeleton organization",
                    "termid": "GO:0030036"
                },
                {
                    "name": "ascospore formation",
                    "termid": "GO:0030437"
                },
                {
                    "name": "autophagy",
                    "termid": "GO:0006914"
                },
                {
                    "name": "carbohydrate metabolic process",
                    "termid": "GO:0005975"
                },
                {
                    "name": "cell adhesion",
                    "termid": "GO:0007155"
                },
                {
                    "name": "cell wall organization or biogenesis",
                    "termid": "GO:0071554"
                },
                {
                    "name": "cellular amino acid metabolic process",
                    "termid": "GO:0006520"
                },
                {
                    "name": "chromatin organization",
                    "termid": "GO:0006325"
                },
                {
                    "name": "conjugation with cellular fusion",
                    "termid": "GO:0000747"
                },
                {
                    "name": "cytoplasmic translation",
                    "termid": "GO:0002181"
                },
                {
                    "name": "detoxification",
                    "termid": "GO:0098754"
                },
                {
                    "name": "dolichol phosphate mannose biosynthetic process",
                    "termid": "GO:0180047"
                },
                {
                    "name": "establishment or maintenance of cell polarity",
                    "termid": "GO:0007163"
                },
                {
                    "name": "generation of precursor metabolites and energy",
                    "termid": "GO:0006091"
                },
                {
                    "name": "glycoprotein biosynthetic process",
                    "termid": "GO:0009101"
                },
                {
                    "name": "GPI anchored protein biosynthesis",
                    "termid": "GO:0180046"
                },
                {
                    "name": "inorganic ion homeostasis",
                    "termid": "GO:0098771"
                },
                {
                    "name": "iron-sulfur cluster assembly",
                    "termid": "GO:0016226"
                },
                {
                    "name": "lipid metabolic process",
                    "termid": "GO:0006629"
                },
                {
                    "name": "mRNA metabolic process",
                    "termid": "GO:0016071"
                },
                {
                    "name": "meiotic nuclear division",
                    "termid": "GO:0140013"
                },
                {
                    "name": "membrane organization",
                    "termid": "GO:0061024"
                },
                {
                    "name": "microtubule cytoskeleton organization",
                    "termid": "GO:0000226"
                },
                {
                    "name": "meiotic drive",
                    "termid": "GO:0110134"
                },
                {
                    "name": "mitochondrial gene expression",
                    "termid": "GO:0140053"
                },
                {
                    "name": "mitochondrion organization",
                    "termid": "GO:0007005"
                },
                {
                    "name": "mitotic cytokinesis",
                    "termid": "GO:0000281"
                },
                {
                    "name": "mitotic sister chromatid segregation",
                    "termid": "GO:0000070"
                },
                {
                    "name": "nitrogen cycle metabolic process",
                    "termid": "GO:0071941"
                },
                {
                    "name": "nucleobase-containing small molecule metabolic process",
                    "termid": "GO:0055086"
                },
                {
                    "name": "nucleocytoplasmic transport",
                    "termid": "GO:0006913"
                },
                {
                    "name": "organelle localization by membrane tethering",
                    "termid": "GO:0140056"
                },
                {
                    "name": "organophosphate metabolic process",
                    "termid": "GO:0019637"
                },

                {
                    "name": "peroxisome organization",
                    "termid": "GO:0007031"
                },
                {
                    "name": "polyamine metabolic process",
                    "termid": "GO:0006595"
                },
                {
                    "name": "protein catabolic process",
                    "termid": "GO:0030163"
                },
                {
                    "name": "protein-containing complex assembly",
                    "termid": "GO:0065003"
                },
                {
                    "name": "protein folding",
                    "termid": "GO:0006457"
                },
                {
                    "name": "protein maturation",
                    "termid": "GO:0051604"
                },
                {
                    "name": "protein modification by small protein conjugation or removal",
                    "termid": "GO:0070647"
                },
                {
                    "name": "protein targeting",
                    "termid": "GO:0006605"
                },
                {
                    "name": "pteridine-containing compound biosynthetic process",
                    "termid": "GO:0042559"
                },
                {
                    "name": "mitotic cell cycle phase transition",
                    "termid": "GO:0044772"
                },
                {
                    "name": "regulation of transcription, DNA-templated",
                    "termid": "GO:0006355"
                },
                {
                    "name": "ribosome biogenesis",
                    "termid": "GO:0042254"
                },
                {
                    "name": "secondary metabolic process",
                    "termid": "GO:0019748"
                },
                {
                    "name": "signaling",
                    "termid": "GO:0023052"
                },
                {
                    "name": "sister chromatid cohesion",
                    "termid": "GO:0007062"
                },
                {
                    "name": "snoRNA metabolic process",
                    "termid": "GO:0016074"
                },
                {
                    "name": "snRNA metabolic process",
                    "termid": "GO:0016073"
                },
                {
                    "name": "sulfur compound metabolic process",
                    "termid": "GO:0006790"
                },
                {
                    "name": "tRNA metabolic process",
                    "termid": "GO:0006399"
                },
                {
                    "name": "telomere organization",
                    "termid": "GO:0032200"
                },
                {
                    "name": "tetrapyrrole metabolic process",
                    "termid": "GO:0033013"
                },
                {
                    "name": "transcription, DNA-templated",
                    "termid": "GO:0006351"
                },
                {
                    "name": "transmembrane transport",
                    "termid": "GO:0055085"
                },
                {
                    "name": "ubiquinone metabolic process",
                    "termid": "GO:0006743"
                },
                {
                    "name": "vesicle-mediated transport",
                    "termid": "GO:0016192"
                },
                {
                    "name": "vitamin metabolic process",
                    "termid": "GO:0006766"
                }
            ]
        },
        "mf_goslim_pombe": {
            "slim_display_name": "Molecular Function slim",
            "doc_path": "/documentation/pombase-go-slim-documentation",
            "full_slim_path": "/browse-curation/fission-yeast-mf-go-slim-terms",
            "description": "S. pombe high level GO molecular function terms",
            "slim_results_description": "A \"GO slim\" is a subset of the Gene Ontology terms selected for a specific purpose in interpreting the functional annotations in an entire organism, or a gene product list derived from an experiment.",
            "cv_name": "molecular_function",
            "terms": [
                {
                    "name": "1,3-beta-glucanosyltransferase activity",
                    "termid": "GO:0042124"
                },
                {
                    "name": "ATPase activity",
                    "termid": "GO:0016887"
                },
                {
                    "name": "DNA-binding transcription factor activity",
                    "termid": "GO:0003700"
                },
                {
                    "name": "GTPase activity",
                    "termid": "GO:0003924"
                },
                {
                    "name": "actin binding",
                    "termid": "GO:0003779"
                },
                {
                    "name": "cargo receptor activity",
                    "termid": "GO:0038024"
                },
                {
                    "name": "catalytic activity, acting on DNA",
                    "termid": "GO:0140097"
                },
                {
                    "name": "catalytic activity, acting on RNA",
                    "termid": "GO:0140098"
                },
                {
                    "name": "catalytic activity, acting on a protein",
                    "termid": "GO:0140096"
                },
                {
                    "name": "catalytic activity, acting on a tRNA",
                    "termid": "GO:0140101"
                },
                {
                    "name": "cell adhesion mediator activity",
                    "termid": "GO:0098631"
                },
                {
                    "name": "cyclase activity",
                    "termid": "GO:0009975"
                },
                {
                    "name": "deacetylase activity",
                    "termid": "GO:0019213"
                },
                {
                    "name": "disulfide oxidoreductase activity",
                    "termid": "GO:0015036"
                },
                {
                    "name": "enzyme regulator activity",
                    "termid": "GO:0030234"
                },
                {
                    "name": "exonuclease activity",
                    "termid": "GO:0004527"
                },
                {
                    "name": "general transcription initiation factor activity",
                    "termid": "GO:0140223"
                },
                {
                    "name": "guanyl-nucleotide exchange factor activity",
                    "termid": "GO:0005085"
                },
                {
                    "name": "histone demethylase activity",
                    "termid": "GO:0032452"
                },
                {
                    "name": "hydrolase activity, acting on carbon-nitrogen (but not peptide) bonds",
                    "termid": "GO:0016810"
                },
                {
                    "name": "hydrolase activity, acting on ester bonds",
                    "termid": "GO:0016788"
                },
                {
                    "name": "hydrolase activity, acting on glycosyl bonds",
                    "termid": "GO:0016798"
                },
                {
                    "name": "intramembrane lipid transporter activity",
                    "termid": "GO:0140303"
                },
                {
                    "name": "isomerase activity",
                    "termid": "GO:0016853"
                },
                {
                    "name": "kinase activity",
                    "termid": "GO:0016301"
                },
                {
                    "name": "ligase activity",
                    "termid": "GO:0016874"
                },
                {
                    "name": "lipid binding",
                    "termid": "GO:0008289"
                },
                {
                    "name": "lipid transfer activity",
                    "termid": "GO:0120013"
                },
                {
                    "name": "lyase activity",
                    "termid": "GO:0016829"
                },
                {
                    "name": "microtubule binding",
                    "termid": "GO:0008017"
                },
                {
                    "name": "molecular adaptor activity",
                    "termid": "GO:0060090"
                },
                {
                    "name": "molecular carrier activity",
                    "termid": "GO:0140104"
                },
                {
                    "name": "molecular function regulator",
                    "termid": "GO:0098772"
                },
                {
                    "name": "molecular sequestering activity",
                    "termid": "GO:0140313"
                },
                {
                    "name": "motor activity",
                    "termid": "GO:0003774"
                },
                {
                    "name": "nucleocytoplasmic carrier activity",
                    "termid": "GO:0140142"
                },
                {
                    "name": "nucleoside-triphosphate diphosphatase activity",
                    "termid": "GO:0047429"
                },
                {
                    "name": "nucleotidyltransferase activity",
                    "termid": "GO:0016779"
                },
                {
                    "name": "oxidoreductase activity",
                    "termid": "GO:0016491"
                },
                {
                    "name": "peptidase activity",
                    "termid": "GO:0008233"
                },
                {
                    "name": "peptide N-acetyltransferase activity",
                    "termid": "GO:0034212"
                },
                {
                    "name": "peroxiredoxin activity",
                    "termid": "GO:0051920"
                },
                {
                    "name": "pheromone activity",
                    "termid": "GO:0005186"
                },
                {
                    "name": "phosphoprotein phosphatase activity",
                    "termid": "GO:0004721"
                },
                {
                    "name": "phosphotransferase activity, for other substituted phosphate groups",
                    "termid": "GO:0016780"
                },
                {
                    "name": "protein deacetylase activity",
                    "termid": "GO:0033558"
                },
                {
                    "name": "protein kinase activity",
                    "termid": "GO:0004672"
                },
                {
                    "name": "protein methyltransferase activity",
                    "termid": "GO:0008276"
                },
                {
                    "name": "protein sequestering activity",
                    "termid": "GO:0140311"
                },
                {
                    "name": "protein tag",
                    "termid": "GO:0031386"
                },
                {
                    "name": "protein transporter activity",
                    "termid": "GO:0140318"
                },
                {
                    "name": "signal sequence binding",
                    "termid": "GO:0005048"
                },
                {
                    "name": "signaling receptor activity",
                    "termid": "GO:0038023"
                },
                {
                    "name": "small molecule sensor activity",
                    "termid": "GO:0140299"
                },
                {
                    "name": "structural molecule activity",
                    "termid": "GO:0005198"
                },
                {
                    "name": "topological DNA entrapment activity",
                    "termid": "GO:0061776"
                },
                {
                    "name": "transcription coactivator activity",
                    "termid": "GO:0003713"
                },
                {
                    "name": "transcription coregulator activity",
                    "termid": "GO:0003712"
                },
                {
                    "name": "transcription elongation regulator activity",
                    "termid": "GO:0003711"
                },
                {
                    "name": "transferase activity, transferring acyl groups",
                    "termid": "GO:0016746"
                },
                {
                    "name": "transferase activity, transferring aldehyde or ketonic groups",
                    "termid": "GO:0016744"
                },
                {
                    "name": "transferase activity, transferring alkyl or aryl (other than methyl) groups",
                    "termid": "GO:0016765"
                },
                {
                    "name": "transferase activity, transferring glycosyl groups",
                    "termid": "GO:0016757"
                },
                {
                    "name": "transferase activity, transferring nitrogenous groups",
                    "termid": "GO:0016769"
                },
                {
                    "name": "transferase activity, transferring one-carbon groups",
                    "termid": "GO:0016741"
                },
                {
                    "name": "transferase activity, transferring sulfur-containing groups",
                    "termid": "GO:0016782"
                },
                {
                    "name": "translation regulator activity",
                    "termid": "GO:0045182"
                },
                {
                    "name": "transmembrane transporter activity",
                    "termid": "GO:0022857"
                },
                {
                    "name": "ubiquitin-like protein transferase activity",
                    "termid": "GO:0019787"
                },
                {
                    "name": "unfolded protein binding",
                    "termid": "GO:0051082"
                }
            ]
        },
        "fypo_slim": {
            "slim_display_name": "Phenotype slim",
            "full_slim_path": "/browse-curation/fypo-slim",
            "description": "High level fission yeast phenotype terms",
            "slim_results_description": "A \"slim\" is a high-level subset of terms from an ontology, used to analyze sets of annotated genes. PomBase has created a slim from the Fission Yeast Phenotype Ontology (FYPO) to provide a summary of fission yeast phenotypes.",
            "cv_name": "single_locus_phenotype",
            "terms": [
                {
                    "name": "abnormal cell morphology",
                    "termid": "FYPO:0000005"
                },
                {
                    "name": "abnormal cytokinesis",
                    "termid": "FYPO:0000032"
                },
                {
                    "name": "abnormal gene expression",
                    "termid": "FYPO:0006551"
                },
                {
                    "name": "abnormal microtubule cytoskeleton organization",
                    "termid": "FYPO:0000054"
                },
                {
                    "name": "abnormal spindle",
                    "termid": "FYPO:0000120"
                },
                {
                    "name": "abnormal sporulation",
                    "termid": "FYPO:0000121"
                },
                {
                    "name": "localization phenotype",
                    "termid": "FYPO:0000138"
                },
                {
                    "name": "cell population growth phenotype",
                    "termid": "FYPO:0000139"
                },
                {
                    "name": "DNA metabolism phenotype",
                    "termid": "FYPO:0000293"
                },
                {
                    "name": "RNA metabolism phenotype",
                    "termid": "FYPO:0000294"
                },
                {
                    "name": "cellular response phenotype",
                    "termid": "FYPO:0000298"
                },
                {
                    "name": "mating phenotype",
                    "termid": "FYPO:0000301"
                },
                {
                    "name": "abnormal mitosis",
                    "termid": "FYPO:0000337"
                },
                {
                    "name": "cell cycle phenotype",
                    "termid": "FYPO:0000631"
                },
                {
                    "name": "abnormal chromosome organization",
                    "termid": "FYPO:0000641"
                },
                {
                    "name": "DNA binding phenotype",
                    "termid": "FYPO:0000653"
                },
                {
                    "name": "catalytic activity phenotype",
                    "termid": "FYPO:0000654"
                },
                {
                    "name": "protein-protein interaction phenotype",
                    "termid": "FYPO:0000702"
                },
                {
                    "name": "vegetative cell phenotype",
                    "termid": "FYPO:0001320"
                },
                {
                    "name": "viable cell population",
                    "termid": "FYPO:0002058"
                },
                {
                    "name": "inviable cell population",
                    "termid": "FYPO:0002059"
                },
                {
                    "name": "abnormal transport",
                    "termid": "FYPO:0001720"
                },
                {
                    "name": "protein-RNA interaction phenotype",
                    "termid": "FYPO:0002131"
                },
                {
                    "name": "abnormal protein metabolic process",
                    "termid": "FYPO:0002274"
                },
                {
                    "name": "abnormal microtubule cytoskeleton",
                    "termid": "FYPO:0002399"
                },
                {
                    "name": "abnormal nucleus",
                    "termid": "FYPO:0002403"
                },
                {
                    "name": "abnormal protein modification",
                    "termid": "FYPO:0002494"
                },
                {
                    "name": "increased resistance to chemical",
                    "termid": "FYPO:0002682"
                },
                {
                    "name": "increased sensitivity to chemical",
                    "termid": "FYPO:0002683"
                },
                {
                    "name": "abnormal cell wall",
                    "termid": "FYPO:0002946"
                },
                {
                    "name": "abnormal actin cytoskeleton organization",
                    "termid": "FYPO:0004803"
                },
                {
                    "name": "abnormal cell wall organization",
                    "termid": "FYPO:0004805"
                },
                {
                    "name": "abnormal cell polarity",
                    "termid": "FYPO:0005568"
                }
            ]
        },
        "pombe_mondo_slim": {
            "slim_display_name": "Disease slim",
            "doc_path": "/browse-curation/disease-slim",
            "full_slim_path": "/browse-curation/disease-slim",
            "description": "High level disease terms",
            "slim_results_description": "A \"slim\" is a high-level subset of terms from an ontology, used to analyze sets of annotated genes. PomBase has created a slim from the Mondo Disease Ontology (Mondo) to provide a simple summary of S. pombe genes with human orthologs implicated in disease.",
            "cv_name": "mondo",
            "terms": [
                {
                    "name": "premature aging syndrome",
                    "termid": "MONDO:0019303"
                },
                {
                    "name": "DNA repair disease",
                    "termid": "MONDO:0021190"
                },
                {
                    "name": "diabetes mellitus (disease)",
                    "termid": "MONDO:0005015"
                },
                {
                    "name": "inherited amino acid metabolic disorder",
                    "termid": "MONDO:0004736"
                },
                {
                    "name": "inborn disorder of purine or pyrimidine metabolism",
                    "termid": "MONDO:0019254"
                },
                {
                    "name": "peroxisomal disease",
                    "termid": "MONDO:0019053"
                },
                {
                    "name": "inherited lipid metabolism disorder",
                    "termid": "MONDO:0002525"
                },
                {
                    "name": "inborn mitochondrial metabolism disorder",
                    "termid": "MONDO:0004069"
                },
                {
                    "name": "lysosomal storage disease",
                    "termid": "MONDO:0002561"
                },
                {
                    "name": "carbohydrate metabolism disease",
                    "termid": "MONDO:0037792"
                },
                {
                    "name": "peripheral neuropathy",
                    "termid": "MONDO:0005244"
                },
                {
                    "name": "neurodegenerative disease",
                    "termid": "MONDO:0005559"
                },
                {
                    "name": "dystonic disorder",
                    "termid": "MONDO:0003441"
                },
                {
                    "name": "epilepsy",
                    "termid": "MONDO:0005027"
                },
                {
                    "name": "cognitive disorder",
                    "termid": "MONDO:0002039"
                },
                {
                    "name": "bone development disease",
                    "termid": "MONDO:0005497"
                },
                {
                    "name": "anemia (disease)",
                    "termid": "MONDO:0002280"
                },
                {
                    "name": "nonsyndromic genetic deafness",
                    "termid": "MONDO:0019497"
                },
                {
                    "name": "eye disease",
                    "termid": "MONDO:0005328"
                },
                {
                    "name": "skin disease",
                    "termid": "MONDO:0005093"
                },
                {
                    "name": "kidney disease",
                    "termid": "MONDO:0005240"
                },
                {
                    "name": "hepatobiliary disease",
                    "termid": "MONDO:0002515"
                },
                {
                    "name": "heart disease",
                    "termid": "MONDO:0005267"
                },
                {
                    "name": "myopathy",
                    "termid": "MONDO:0005336"
                },
                {
                    "name": "proteostasis deficiencies",
                    "termid": "MONDO:0021179"
                },
                {
                    "name": "inherited porphyria",
                    "termid": "MONDO:0019142"
                },
                {
                    "name": "immune system disease",
                    "termid": "MONDO:0005046"
                },
                {
                    "name": "cancer",
                    "termid": "MONDO:0004992"
                },
                {
                    "name": "autosomal dominant disease",
                    "termid": "MONDO:0000426"
                },
                {
                    "name": "autosomal recessive disease",
                    "termid": "MONDO:0006025"
                },
                {
                    "name": "gamma-glutamyl cycle",
                    "termid": "MONDO:0019241"
                },
                {
                    "name": "digestive system disease",
                    "termid": "MONDO:0004335"
                },
                {
                    "name": "hematologic disease",
                    "termid": "MONDO:0005570"
                },
                {
                    "name": "infertility disorder",
                    "termid": "MONDO:0005047"
                },
                {
                    "name": "central nervous system malformation",
                    "termid": "MONDO:0020022"
                },
                {
                    "name": "disorder of glycosylation",
                    "termid": "MONDO:0024322"
                },
                {
                    "name": "neurodevelopmental disorder",
                    "termid": "MONDO:0700092"
                },
                {
                    "name": "congenital nervous system disorder",
                    "termid": "MONDO:0002320"
                },
                {
                    "name": "metabolic disease",
                    "termid": "MONDO:0005066"
                }
            ]
        }
    },
    "reference_page_config": {
        "triage_status_to_ignore": []
    },
    "extra_database_aliases": {
        "tigrfams": "JCVI_TIGRFAMS",
        "ssf": "SUPERFAMILY",
        "mobidblt": "MobiDB",
        "amigo": "GO",
        "cathgene3d": "Gene3D",
        "scanprosite": "Prosite",
        "prositeprofiles": "PROSITE profiles",
        "prosite profiles": "PROSITE profiles",
        "prositepatterns": "PROSITE patterns",
        "prosite patterns": "PROSITE patterns",
        "coils": "Coiled coils"
    },
    "misc_external_links": {
        "MalaCards": "https://www.malacards.org/card/<<IDENTIFIER>>",
        "Monarch": "https://monarchinitiative.org/MONDO:<<IDENTIFIER>>"
    },
    "interpro": {
        "dbnames_to_filter": ["PIRSR"]
    },
    "server": {
        "subsets": {
            "prefixes_to_remove": [
                "interpro:CDD",
                "interpro:MOBIDBLT",
                "interpro:PANTHER",
                "interpro:PANTHER",
                "interpro:PFAM",
                "interpro:PIRSF",
                "interpro:PIRSR",
                "interpro:PRINTS",
                "interpro:PRODOM",
                "interpro:PROFILE",
                "interpro:PROSITE",
                "interpro:SFLD",
                "interpro:SMART",
                "interpro:SSF",
                "interpro:TIGRFAMs",
                "interpro"
            ]
        },
        "solr_url": "http://localhost:8983/solr",
        "django_url": "http://localhost:8999",
        "exact_synonym_boost": 0.25,
        "narrow_synonym_boost": 0.1,
        "distant_synonym_boost": 0.05,
        "term_definition_boost": 0.05,
        "cv_name_for_terms_search": "(molecular_function OR biological_process OR cellular_component OR fission_yeast_phenotype OR mondo)",
        "gene_uniquename_re": "^SP([ABCN][CTP]|RR|SN|MIT|MT)[\\d\\w]*\\.\\d\\d\\d?\\d?c?$"
    },
    "gene_results": {
        "field_config": {
            "uniquename": {
                "display_name": "Systematic ID",
                "column_type": "string"
            },
            "name": {
                "display_name": "Gene name",
                "column_type": "string"
            },
            "synonyms": {
                "display_name": "Synonyms",
                "column_type": "list"
            },
            "pdb_ids": {
                "display_name": "PDB structure IDs",
                "column_type": "list"
            },
            "paralogs": {
                "display_name": "Paralog IDs",
                "column_type": "list"
            },
            "rnacentral_id": {
                "display_name": "RNACentral ID",
                "column_type": "string"
            },
            "product": {
                "display_name": "Product description",
                "column_type": "string"
            },
            "uniprot_identifier": {
                "display_name": "UniProt ID",
                "column_type": "string"
            },
            "feature_type": {
                "display_name": "Feature type",
                "column_type": "string"
            },
            "start_pos": {
                "display_name": "Start position",
                "column_type": "number"
            },
            "end_pos": {
                "display_name": "End position",
                "column_type": "number"
            },
            "chromosome_name": {
                "display_name": "Chromosome",
                "column_type": "string"
            },
            "strand": {
                "display_name": "Strand",
                "column_type": "string"
            },
            "physical_interactors": {
                "display_name": "Physical interactors",
                "column_type": "gene_list"
            },
            "orthologs:4932": {
                "display_name": "Budding yeast orthologs",
                "column_type": "orthologs"
            },
            "orthologs:4897": {
                "display_name": "S. japonicus orthologs",
                "column_type": "orthologs"
            },
            "orthologs:9606": {
                "display_name": "Human orthologs",
                "column_type": "orthologs"
            },
            "deletion_viability": {
                "display_name": "Deletion viability",
                "column_type": "attribute",
                "attr_values": [
                    {
                        "name": "inviable",
                        "color": "#c32"
                    },
                    {
                        "name": "depends_on_conditions",
                        "color": "#66f",
                        "display_name": "variable"
                    },
                    {
                        "name": "viable",
                        "color": "#3d3"
                    },
                    {
                        "name": "unknown",
                        "color": "#fff",
                        "display_name": "no data"
                    }
                ]
            },
            "ortholog_taxonids:4932": {
                "display_name": "Budding yeast ortholog",
                "column_type": "ortholog",
                "attr_values": [
                    {
                        "name": "absent",
                        "color": "#c32"
                    },
                    {
                        "name": "present",
                        "color": "#3c2"
                    }
                ]
            },
            "ortholog_taxonids:4897": {
                "display_name": "S. japonicus ortholog",
                "column_type": "ortholog",
                "attr_values": [
                    {
                        "name": "absent",
                        "color": "#c32"
                    },
                    {
                        "name": "present",
                        "color": "#3d3"
                    }
                ]
            },
            "ortholog_taxonids:9606": {
                "display_name": "Human ortholog",
                "column_type": "ortholog",
                "attr_values": [
                    {
                        "name": "absent",
                        "color": "#c32"
                    },
                    {
                        "name": "present",
                        "color": "#3d3"
                    }
                ]
            },
            "tmm": {
                "display_name": "Transmembrane domain",
                "column_type": "attribute",
                "attr_values": [
                    {
                        "name": "present",
                        "color": "#283048"
                    },
                    {
                        "name": "absent",
                        "color": "#e8e8e8"
                    },
                    {
                        "name": "not_applicable",
                        "display_name": "not applicable",
                        "color": "#bbf"
                    }
                ]
            },
            "signal_peptide": {
                "display_name": "Signal peptides",
                "column_type": "attribute",
                "attr_values": [
                    {
                        "name": "present",
                        "color": "#283048"
                    },
                    {
                        "name": "absent",
                        "color": "#e8e8e8"
                    },
                    {
                        "name": "not_applicable",
                        "display_name": "not applicable",
                        "color": "#bbf"
                    }
                ]
            },
            "go_process_superslim": {
                "display_name": "GO process",
                "column_type": "ontology_term",
                "attr_values": [
                    {
                        "name": "signaling",
                        "termid": "GO:0023052",
                        "color": "#9b9144"
                    },
                    {
                        "name": "gene expression",
                        "termid": "GO:0010467",
                        "color": "#5f1827"
                    },
                    {
                        "name": "chromatin organization",
                        "termid": "GO:0006325",
                        "color": "#9d7b69"
                    },
                    {
                        "name": "protein folding",
                        "termid": "GO:0006457",
                        "color": "#5544ff"
                    },
                    {
                        "name": "cellular component biogenesis",
                        "termid": "GO:0044085",
                        "color": "#da4837"
                    },
                    {
                        "name": "DNA metabolic process",
                        "termid": "GO:0006259",
                        "color": "#198744"
                    },
                    {
                        "name": "cell cycle",
                        "termid": "GO:0007049",
                        "color": "#e41532"
                    },
                    {
                        "name": "cytoskeleton organization",
                        "termid": "GO:0007010",
                        "color": "#cc64d9"
                    },
                    {
                        "name": "membrane organization",
                        "termid": "GO:0061024",
                        "color": "#efbf98"
                    },
                    {
                        "name": "lipid metabolic process",
                        "termid": "GO:0006629",
                        "color": "#394b2d"
                    },
                    {
                        "name": "small molecule metabolic process",
                        "termid": "GO:0044281",
                        "color": "#d998f5"
                    },
                    {
                        "name": "generation of precursor metabolites and energy",
                        "termid": "GO:0006091",
                        "color": "#e5c17c"
                    },
                    {
                        "name": "transport",
                        "termid": "GO:0006810",
                        "color": "#c2dd36"
                    },
                    {
                        "name": "cellular catabolic process",
                        "termid": "GO:0044248",
                        "color": "#bbc9b7"
                    },
                    {
                        "name": "detoxification",
                        "termid": "GO:0098754",
                        "color": "#9960d8"
                    },
                    {
                        "name": "other",
                        "color": "#a73"
                    },
                    {
                        "name": "unknown",
                        "color": "#fff"
                    }
                ]
            },
            "go_component": {
                "display_name": "GO component",
                "column_type": "ontology_term",
                "attr_values": [
                    {
                        "name": "nucleus",
                        "termid": "GO:0005634",
                        "color": "#c32"
                    },
                    {
                        "name": "endoplasmic reticulum",
                        "termid": "GO:0005783",
                        "color": "#4f4"
                    },
                    {
                        "name": "mitochondrion",
                        "termid": "GO:0005739",
                        "color": "#04f"
                    },
                    {
                        "name": "cytoplasm",
                        "termid": "GO:0005737",
                        "color": "#ca3"
                    },
                    {
                        "name": "other",
                        "color": "#aaa"
                    },
                    {
                        "name": "unknown",
                        "color": "#fff"
                    }
                ]
            },
            "go_function": {
                "display_name": "GO function",
                "column_type": "ontology_term",
                "attr_values": [
                    {
                        "name": "oxidoreductase activity",
                        "termid": "GO:0016491",
                        "color": "#89a6a1"
                    },
                    {
                        "name": "hydrolase activity",
                        "termid": "GO:0016787",
                        "color": "#2a394a"
                    },
                    {
                        "name": "transferase activity",
                        "termid": "GO:0016740",
                        "color": "#6d3ba4"
                    },
                    {
                        "name": "ligase activity",
                        "termid": "GO:0016874",
                        "color": "#da9d46"
                    },
                    {
                        "name": "cyclase activity",
                        "termid": "GO:0009975",
                        "color": "#d770f5"
                    },
                    {
                        "name": "lyase activity",
                        "termid": "GO:0016829",
                        "color": "#99a1c0"
                    },
                    {
                        "name": "catalytic activity",
                        "termid": "GO:0003824",
                        "color": "#dd37de",
                        "display_name": "other catalytic activity"
                    },
                    {
                        "name": "molecular adaptor activity",
                        "termid": "GO:0060090",
                        "color": "#3e9"
                    },
                    {
                        "name": "enzyme regulator activity",
                        "termid": "GO:0030234",
                        "color": "#feb62f"
                    },
                    {
                        "name": "DNA binding",
                        "termid": "GO:0003677",
                        "color": "#821fad"
                    },
                    {
                        "name": "transcription regulator activity",
                        "termid": "GO:0140110",
                        "color": "#cb3063"
                    },
                    {
                        "name": "transporter activity",
                        "termid": "GO:0005215",
                        "color": "#f498f0"
                    },
                    {
                        "name": "cytoskeletal protein binding",
                        "termid": "GO:0008092",
                        "color": "#6ba420"
                    },
                    {
                        "name": "unfolded protein binding",
                        "termid": "GO:0051082",
                        "color": "#21a18f"
                    },
                    {
                        "name": "RNA binding",
                        "termid": "GO:0003723",
                        "color": "#f6a0cd"
                    },
                    {
                        "name": "metal ion binding",
                        "termid": "GO:0046872",
                        "color": "#bc6384"
                    },
                    {
                        "name": "lipid binding",
                        "termid": "GO:0008289",
                        "color": "#22849b"
                    },
                    {
                        "name": "cell adhesion mediator activity",
                        "termid": "GO:0098631",
                        "color": "#3f6865"
                    },
                    {
                        "name": "structural molecule activity",
                        "termid": "GO:0005198",
                        "color": "#cdb4da"
                    },
                    {
                        "name": "other",
                        "color": "#a73"
                    },
                    {
                        "name": "unknown",
                        "color": "#fff"
                    }
                ]
            },
            "characterisation_status": {
                "display_name": "Characterisation status",
                "column_type": "attribute",
                "attr_values": [
                    {
                        "name": "biological role published",
                        "color": "#2d3"
                    },
                    {
                        "name": "dubious",
                        "color": "#299"
                    },
                    {
                        "name": "Schizosaccharomyces pombe specific protein, uncharacterized",
                        "display_name": "S. pombe specific, uncharacterized",
                        "color": "#359"
                    },
                    {
                        "name": "Schizosaccharomyces specific protein, uncharacterized",
                        "display_name": "Schizo. specific, uncharacterized",
                        "color": "#9af"
                    },
                    {
                        "name": "fission yeast specific family",
                        "color": "#23a"
                    },
                    {
                        "name": "biological role inferred",
                        "color": "#c22"
                    },
                    {
                        "name": "transposon",
                        "color": "#d72"
                    },
                    {
                        "name": "conserved unknown",
                        "color": "#36f"
                    },
                    {
                        "name": "meiotic driver",
                        "display_name": "meiotic driver (selfish genes)",
                        "color": "#8a9"
                    },
                    {
                        "name": "unknown",
                        "display_name": "not curated for this datatype",
                        "color": "#aaa"
                    }
                ]
            },
            "taxonomic_distribution": {
                "display_name": "Taxonomic distribution",
                "column_type": "attribute",
                "attr_values": [
                    {
                        "name": "fungi and prokaryotes",
                        "color": "#1c2"
                    },
                    {
                        "name": "eukaryotes only, fungi and metazoa",
                        "color": "#de3"
                    },
                    {
                        "name": "eukaryotes and prokaryotes",
                        "color": "#35b"
                    },
                    {
                        "name": "fungi only",
                        "color": "#39e"
                    },
                    {
                        "name": "S. pombe specific",
                        "color": "#23a"
                    },
                    {
                        "name": "Schizos. specific",
                        "color": "#a26"
                    },
                    {
                        "name": "dubious",
                        "color": "#f52"
                    },
                    {
                        "name": "not curated",
                        "color": "#882"
                    },
                    {
                        "name": "other",
                        "color": "#bbb"
                    }
                ]
            },
            "molecular_weight": {
                "display_name": "Protein molecular weight",
                "column_type": "number"
            },
            "protein_length": {
                "display_name": "Protein length",
                "column_type": "number"
            },
            "spliced_rna_length": {
                "display_name": "Spliced RNA length",
                "column_type": "number"
            },
            "unspliced_rna_length": {
                "display_name": "Unspliced RNA length",
                "column_type": "number"
            },
            "protein_length_bin": {
                "display_name": "Protein length (bins)",
                "column_type": "bins",
                "attr_values": [
                    {
                        "name": "1-100",
                        "color": "#e14e4e",
                        "bin_start": 1,
                        "bin_end": 100
                    },
                    {
                        "name": "101-200",
                        "color": "#d0804b",
                        "bin_start": 101,
                        "bin_end": 200
                    },
                    {
                        "name": "201-300",
                        "color": "#e0b030",
                        "bin_start": 201,
                        "bin_end": 300
                    },
                    {
                        "name": "301-400",
                        "color": "#3c2",
                        "bin_start": 301,
                        "bin_end": 400
                    },
                    {
                        "name": "401-500",
                        "color": "#40d3a6",
                        "bin_start": 401,
                        "bin_end": 500
                    },
                    {
                        "name": "501-600",
                        "color": "#30a0d0",
                        "bin_start": 501,
                        "bin_end": 600
                    },
                    {
                        "name": "601-700",
                        "color": "#6a5be0",
                        "bin_start": 601,
                        "bin_end": 700
                    },
                    {
                        "name": "701-",
                        "color": "#d054e3",
                        "bin_start": 701,
                        "bin_end": 999999999
                    },
                    {
                        "name": "unknown",
                        "display_name": "unknown / not applicable",
                        "color": "#777"
                    }
                ]
            },
            "gocam_ids": {
                "display_name": "GO-CAM IDs",
                "column_type": "list"
            }
        },
        "gene_summary_field_names": [
            "uniquename",
            "name",
            "product",
            "uniprot_identifier",
            "synonyms",
            "feature_type",
            "start_pos",
            "end_pos",
            "chromosome_name",
            "strand",
            "orthologs:4932",
            "orthologs:4897",
            "orthologs:9606"
        ],
        "gene_table_field_names": [
            "uniquename",
            "name",
            "product",
            "uniprot_identifier",
            "synonyms",
            "feature_type",
            "start_pos",
            "end_pos",
            "chromosome_name",
            "strand",
            "orthologs:4932",
            "orthologs:4897",
            "orthologs:9606",
            "physical_interactors",
            "deletion_viability",
            "tmm",
            "characterisation_status",
            "taxonomic_distribution",
            "pdb_ids",
            "paralogs",
            "gocam_ids",
            "rnacentral_id",
            "molecular_weight",
            "protein_length",
            "protein_length_bin",
            "spliced_rna_length",
            "unspliced_rna_length"
        ],
        "visualisation_extra_column_cv_names": [
            "molecular_function",
            "biological_process",
            "cellular_component",
            "sequence",
            "mondo"
        ],
        "visualisation_field_names": [
            "deletion_viability",
            "ortholog_taxonids:4932",
            "ortholog_taxonids:4897",
            "ortholog_taxonids:9606",
            "tmm",
            "signal_peptide",
            "go_process_superslim",
            "go_component",
            "go_function",
            "characterisation_status",
            "taxonomic_distribution",
            "protein_length_bin"
        ],
        "slim_table_slim_names": [
            "mf_goslim_pombe",
            "bp_goslim_pombe",
            "cc_goslim_pombe",
            "fypo_slim",
            "pombe_mondo_slim"
        ]
    },
    "file_exports": {
        "site_map_term_prefixes": [
            "GO:",
            "FYPO:"
        ],
        "site_map_reference_prefixes": [
            "PMID:"
        ],
        "include_nd_lines": true,
        "macromolecular_complexes": {
            "parent_complex_termid": "GO:0032991",
            "excluded_terms": [
            ]
        },
        "rnacentral": {
            "export_so_ids": [
                "SO:0000252",
                "SO:0000253",
                "SO:0000274",
                "SO:0000275",
                "SO:0000655",
                "SO:0001877",
                "SO:0002247"
            ]
        },
        "annotation_subsets": [
            {
                "term_ids": [
                    "FYPO:0002683"
                ],
                "file_name": "increased_sensitivity_to_chemical.tsv",
                "single_or_multi_locus": "single",
                "columns": [
                    {
                        "name": "gene_uniquename",
                        "display_name": "Systematic ID"
                    },
                    {
                        "name": "gene_name",
                        "display_name": "Gene name"
                    },
                    {
                        "name": "allele",
                        "display_name": "Allele"
                    },
                    {
                        "name": "termid",
                        "display_name": "Term ID"
                    },
                    {
                        "name": "term_name",
                        "display_name": "Term name"
                    }
                ]
            },
            {
                "term_ids": [
                    "FYPO:0002682"
                ],
                "file_name": "increased_resistance_to_chemical.tsv",
                "single_or_multi_locus": "single",
                "columns": [
                    {
                        "name": "gene_uniquename",
                        "display_name": "Systematic ID"
                    },
                    {
                        "name": "gene_name",
                        "display_name": "Gene name"
                    },
                    {
                        "name": "allele",
                        "display_name": "Allele"
                    },
                    {
                        "name": "termid",
                        "display_name": "Term ID"
                    },
                    {
                        "name": "term_name",
                        "display_name": "Term name"
                    }
                ]
            }
        ],
        "nd_reference": "GO_REF:0000015",
        "gpad_gpi": {
            "go_aspect_terms": {
                "molecular_function": "GO:0003674",
                "cellular_component": "GO:0005575",
                "biological_process": "GO:0008150"
            },
            "extension_relation_mappings": {
                "not_happens_during": null,
                "not_exists_during": null,
                "activated_by": null,
                "exists_during": "RO:0002490",
                "regulates_activity_of": "RO:0002233",
                "directly_negatively_regulates": "RO:0002233",
                "directly_positively_regulates": "RO:0002233",
                "regulates_expression_of": "RO:0002233",
                "regulates_transcription_of": "RO:0002233",
                "regulates_translation_of": "RO:0002233",
                "occurs_at": "BFO:0000066",
                "coincident_with": "RO:0002008",
                "has_input": "RO:0002233"
            },
            "transcript_gene_so_term_map": {
                "SO:0000234": "SO:0001217",
                "SO:0000516": "SO:0000336",
                "SO:0000252": "SO:0001637",
                "SO:0000253": "SO:0001272",
                "SO:0000274": "SO:0001268",
                "SO:0000275": "SO:0001267",
                "SO:0000655": "SO:0001263",
                "SO:0001877": "SO:0001641",
                "SO:0002247": "SO:0002342",
                "SO:0000602": null,
                "SO:0000644": null
            }
        },
        "phaf_cv_name": "single_locus_phenotype",
        "phaf_parental_strain": {
            "4896": "972 h-"
        }
    },
    "term_display_names": {
        "regional_centromere": "centromere",
        "regional_centromere_central_core": "centromere central core"
    },
    "protein_feature_db_order": [
        "Pfam",
        "CDD",
        "PROSITE",
        "SMART",
        "PRINTS",
        "CATH-FUNFAM",
        "CATH-GENE3D",
        "SUPERFAMILY",
        "PANTHER",
        "PIRSF",
        "NCBIFAM",
        "SFLD",
        "OTHER",
        "DeepTMHMM"
    ],
    "protein_feature_table": {
        "feature_types": {
            "PRINTS": {
                "min_max_only": true
            }
        }
    },
    "protein_feature_view": {
        "modification_extension_rel_types": [
            "added_during", "added_by", "affected_by", "removed_by",
            "present_during", "increased_during", "level_fluctuates_during",
            "increased_in_presence_of"
        ],
        "widget_tracks": [
            "AA substitution positions",
            "Modifications",
            "Glycosylation sites",
            "Pfam domains",
            "DeepTMHMM",
            "TM domains",
            "Disordered regions",
            "Low complexity",
            "Coiled coils",
            "Disulfide bonds",
            "Binding sites",
            "Active sites",
            "Localization signals",
            "Signal-Peptide-DeepTMHMM",
            "Propeptides",
            "Cleavage sites"
        ],
        "domains_and_features_tracks": [
            "Binding sites",
            "Active sites",
            "Conserved motifs",
            "MobiDB",
            "MobiDB-Disorder",
            "MobiDB-Glycine-rich",
            "MobiDB-Negative-Polyelectrolyte",
            "MobiDB-Polar",
            "MobiDB-Polyampholyte",
            "MobiDB-Positive-Polyelectrolyte",
            "MobiDB-Proline-rich",
            "CDD",
            "CATH-FunFam",
            "CATH-Gene3D",
            "HAMAP",
            "NCBIFAM",
            "PANTHER",
            "Pfam",
            "PIRSF",
            "PRINTS",
            "PROSITE patterns",
            "PROSITE profiles",
            "SFLD",
            "SMART",
            "SUPERFAMILY",
            "Localization signals",
            "Signal-Peptide-DeepTMHMM",
            "DeepTMHMM",
            "TM domains",
            "Disordered regions",
            "Low complexity",
            "Coiled coils"
        ],
        "modification_section_tracks": [
            "Modifications",
            "Disulfide bonds"
        ],
        "modification_groups": [
            {
                "termid": "MOD:01875",
                "name": "N6-acylated L-lysine"
            },
            {
                "termid": "MOD:01155",
                "name": "lipoconjugated residue"
            },
            {
                "termid": "MOD:00408",
                "name": "N-acetylated residue"
            },
            {
                "termid": "MOD:00696",
                "name": "phosphorylated residue"
            },
            {
                "termid": "MOD:00427",
                "name": "methylated residue"
            },
            {
                "termid": "MOD:00764",
                "name": "glycoconjugated residue"
            },
            {
                "termid": "MOD:00905",
                "name": "modified L-cysteine residue"
            }
        ],
        "full_display_excluded": [
            "MobiDB-Low-complexity",
            "Pfam domains"
        ]
    },
    "gene_expression": {
        "max_gene_ex_plot_genes": 250,
        "datasets": [
            {
                "name": "G1 phase - protein (Carpy)",
                "plot_display_name": "G1 phase\n(Carpy)",
                "first_author": "Carpy",
                "pubmed_id": "PMID:24763107",
                "level_type": "protein level",
                "level_type_termid": "PBO:0006310",
                "scale": "single_cell",
                "during": "mitotic G1 phase",
                "during_termid": "GO:0000080"
            },
            {
                "name": "G2 phase - protein (Carpy)",
                "plot_display_name": "G2 phase\n(Carpy)",
                "first_author": "Carpy",
                "pubmed_id": "PMID:24763107",
                "level_type": "protein level",
                "level_type_termid": "PBO:0006310",
                "scale": "single_cell",
                "during": "mitotic G2 phase",
                "during_termid": "GO:0000085"
            },
            {
                "name": "M phase - protein (Carpy)",
                "plot_display_name": "M phase\n(Carpy)",
                "first_author": "Carpy",
                "pubmed_id": "PMID:24763107",
                "level_type": "protein level",
                "level_type_termid": "PBO:0006310",
                "scale": "single_cell",
                "during": "mitotic M phase",
                "during_termid": "GO:0000087"
            },
            {
                "name": "S phase - protein (Carpy)",
                "plot_display_name": "S phase\n(Carpy)",
                "first_author": "Carpy",
                "pubmed_id": "PMID:24763107",
                "level_type": "protein level",
                "level_type_termid": "PBO:0006310",
                "scale": "single_cell",
                "during": "mitotic S phase",
                "during_termid": "GO:0000084"
            },
            {
                "name": "veg. growth - protein (Carpy)",
                "plot_display_name": "veg. growth\n(Carpy)",
                "first_author": "Carpy",
                "pubmed_id": "PMID:24763107",
                "level_type": "protein level",
                "level_type_termid": "PBO:0006310",
                "scale": "single_cell",
                "during": "single-celled organism vegetative growth phase",
                "during_termid": "GO:0072690"
            },
            {
                "name": "G1 quiescence - protein (Marguerat)",
                "plot_display_name": "G1 quiescence\n(Marguerat)",
                "first_author": "marguerat",
                "pubmed_id": "PMID:23101633",
                "level_type": "protein level",
                "level_type_termid": "PBO:0006310",
                "scale": "population_wide",
                "during": "cell quiescence following G1 arrest due to nitrogen limitation",
                "during_termid": "PBQ:0000003"
            },
            {
                "name": "veg. growth - protein (Marguerat)",
                "plot_display_name": "veg. growth\n(Marguerat)",
                "first_author": "Marguerat",
                "pubmed_id": "PMID:23101633",
                "level_type": "protein level",
                "level_type_termid": "PBO:0006310",
                "scale": "population_wide",
                "during": "single-celled organism vegetative growth phase",
                "during_termid": "GO:0072690"
            },
            {
                "name": "G1 quiescence - RNA (Marguerat)",
                "plot_display_name": "G1 quiescence\n(Marguerat)",
                "first_author": "Marguerat",
                "pubmed_id": "PMID:23101633",
                "level_type": "RNA level",
                "level_type_termid": "PBO:0011963",
                "scale": "population_wide",
                "during": "cell quiescence following G1 arrest due to nitrogen limitation",
                "during_termid": "PBQ:0000003"
            },
            {
                "name": "veg. growth - RNA (Marguerat)",
                "plot_display_name": "veg. growth\n(Marguerat)",
                "first_author": "Marguerat",
                "pubmed_id": "PMID:23101633",
                "level_type": "RNA level",
                "level_type_termid": "PBO:0011963",
                "scale": "population_wide",
                "during": "single-celled organism vegetative growth phase",
                "during_termid": "GO:0072690"
            }
        ]
    },
    "dataset_versions": {
        "ontology_details": {
            "PSI-MOD": {
                "description": "Protein Modifications Ontology",
                "external_link": "https://github.com/HUPO-PSI/psi-mod-CV"
            },
            "biological_process": {
                "description": "GO biological process",
                "external_link": "https://geneontology.org/docs/ontology-documentation/"
            },
            "cell": {
                "description": "The Cell Ontology of biological cell types (CL)",
                "external_link": "https://obophenotype.github.io/cell-ontology/"
            },
            "cellular_component": {
                "description": "GO cellular component",
                "external_link": "https://geneontology.org/docs/ontology-documentation/"
            },
            "chebi_ontology": {
                "description": "Chemical Entities of Biological Interest Ontology (CHEBI)",
                "external_link": "https://www.ebi.ac.uk/chebi/about/"
            },
            "fission_yeast_phenotype": {
                "description": "A formal ontology of phenotypes observed in fission yeast (FYPO)",
                "external_link": "https://www.pombase.org/browse-curation/fission-yeast-phenotype-ontology"
            },
            "fission_yeast_phenotype_condition": {
                "description": "FYPO condition ontology"
            },
            "molecular_function": {
                "description": "GO molecular function",
                "external_link": "https://geneontology.org/docs/ontology-documentation/"
            },
            "mondo": {
                "description": "Mondo disease ontology",
                "external_link": "https://mondo.monarchinitiative.org/"
            },
            "pombase_relations": {
                "description": "PomBase specific ontology relations"
            },
            "protein": {
                "description": "PRO protein-relation entity ontology (PRO)",
                "external_link": "https://proconsortium.org/"
            },
            "sequence": {
                "description": "Ontology of sequence features used in biological sequence annotation (SO)",
                "external_link": "http://www.sequenceontology.org/"
            }
        }
    },
    "stats": {
        "curated_vs_curatable_min_year": 2009,
        "annotation_type_counts_min_year": 2005,
        "annotation_type_groups": [
            {
                "display_name": "GO",
                "cv_names": ["molecular_function", "biological_process", "cellular_component"]
            },
            {   "display_name": "Phenotype",
                "cv_names": ["fission_yeast_phenotype"]
            },
            {
                "display_name": "Modifications",
                "cv_names": ["PSI-MOD"]
            },
            {
                "display_name": "Gene expression",
                "cv_names": ["gene_ex", "PomGeneExProt", "PomGeneExRD", "PomGeneExRNA"]
            },
            {
                "display_name": "Interactions",
                "cv_names": ["interacts_genetically", "interacts_physically"]
            },
            {
                "display_name": "Orthologs",
                "cv_names": ["orthologous_to"]
            },
            {
                "display_name": "Other",
                "cv_names": [
                    "pombase_family_or_domain", "complementation", "EC numbers",
                    "PomBase gene characterisation status", "external_link",
                    "PomBase gene products", "ex_tools", "genome_org",
                    "m_f_g", "misc", "mondo",
                    "name_description", "sequence", "species_dist", "warning",
                    "cat_act", "subunit_composition"]
            }
        ],
        "feature_types_table": [
            {
                "sub_title": "Repeat type",
                "type_names": [
                    "dg_repeat",
                    "dh_repeat",
                    "long_terminal_repeat",
                    "LTR_retrotransposon",
                    "nuclear_mt_pseudogene",
                    "regional_centromere_inner_repeat_region",
                    "repeat_region"
                ]
            },
            {
                "sub_title": "Other",
                "type_names": [
                    "gap",
                    "low_complexity_region",
                    "mating_type_region",
                    "regional_centromere",
                    "regional_centromere_central_core"
                ]
            }
        ]
    },
    "apicuron": {
        "resource_id": "pombase"
    }
}
